// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./../img/hamburger.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./../img/sign-in-alt.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./../img/mail.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./../img/cross.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./../img/ind-expand-arrow.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./../img/social-vk.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("./../img/social-telegram.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("./../img/link.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("./../img/star.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("./../img/angle.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("./../img/search.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("./../img/chevron-down.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("./../img/wallet.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("./../img/car.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("./../img/phone.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("@src/img/bg.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("@src/img/com-header-bg.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("@src/img/bg-lime.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("@src/img/logo-lime.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("./../img/star-active.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("./../img/share-copy.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("./../img/share-vk.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("./../img/share-ok.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("./../img/share-tg.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_24___ = new URL("./../img/share-whatsapp.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
! tailwindcss v3.3.2 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
*/

html {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */
  -moz-tab-size: 4; /* 3 */
  -o-tab-size: 4;
     tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Ubuntu, Cantarell, Noto Sans, sans-serif, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  text-decoration: underline;
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font family by default.
2. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-size: 1em; /* 2 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgba(59, 130, 246, 0.5);
  --tw-ring-offset-shadow: 0 0 rgba(0,0,0,0);
  --tw-ring-shadow: 0 0 rgba(0,0,0,0);
  --tw-shadow: 0 0 rgba(0,0,0,0);
  --tw-shadow-colored: 0 0 rgba(0,0,0,0);
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgba(59, 130, 246, 0.5);
  --tw-ring-offset-shadow: 0 0 rgba(0,0,0,0);
  --tw-ring-shadow: 0 0 rgba(0,0,0,0);
  --tw-shadow: 0 0 rgba(0,0,0,0);
  --tw-shadow-colored: 0 0 rgba(0,0,0,0);
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
.\\!container {
  width: 100% !important;
}
.container {
  width: 100%;
}
@media (min-width: 1184px) {

  .\\!container {
    max-width: 1184px !important;
  }

  .container {
    max-width: 1184px;
  }
}
.icon, .ya-share2 .ya-share2__popup > .ya-share2__list .ya-share2__item_service_whatsapp .ya-share2__icon, .ya-share2 .ya-share2__popup > .ya-share2__list .ya-share2__item_service_telegram .ya-share2__icon, .ya-share2 .ya-share2__popup > .ya-share2__list .ya-share2__item_service_odnoklassniki .ya-share2__icon, .ya-share2 .ya-share2__popup > .ya-share2__list .ya-share2__item_service_vkontakte .ya-share2__icon, .ya-share2 .ya-share2__popup > .ya-share2__list .ya-share2__item_copy .ya-share2__icon, .icon-phone, .icon-car, .icon-wallet, .icon-spinner, .icon-chevron-down, .icon-search, .icon-angle, .content .wp-block-gallery-stick, .icon-star-active, .icon-star, .icon-link, .icon-social-telegram, .icon-social-vk, .icon-ind-expand-arrow, .icon-cross, .icon-mail, .icon-sign-in-alt, .icon-hamburger, .icon-fixed {
    background-size: 100% 100%;
    background-repeat: no-repeat;
    display: block;
    content: "";
  }
.icon-fixed {
    background-image: var(--icon);
  }
.icon-hamburger {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  }
.icon-sign-in-alt {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  }
.icon-mail {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  }
.icon-cross {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  }
.icon-ind-expand-arrow {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  }
.icon-social-vk {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  }
.icon-social-telegram {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  }
.icon-link {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  }
.icon-fixed-star {
    --icon: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  }
.icon-angle, .content .wp-block-gallery-stick {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  }
.icon-search {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  }
.icon-chevron-down {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
  }
.icon-wallet {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
  }
.icon-car {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
  }
.icon-phone {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
  }
.range {
    position: relative;
    height: 0.25rem;
    cursor: pointer;
    -webkit-appearance: none;
       -moz-appearance: none;
            appearance: none;
    --tw-bg-opacity: 1;
    background-color: rgba(235, 235, 235, 1);
    background-color: rgba(235, 235, 235, var(--tw-bg-opacity));
  }
.range:focus-visible {
    outline: none;
  }
.range:before {
    position: absolute;
    left: -100%;
    top: 0;
    bottom: 0;
    width: 100%;
    transform: translateX(0);
    transform: translateX(var(--percent, 0));
    background-color: #5D9922;
    display: block;
    content: "";
    z-index: 1;
  }
.range::-webkit-slider-thumb {
    -webkit-appearance: none;
            appearance: none;
    background: #fff;
    border: 4px solid #5D9922;
    width: 24px;
    height: 24px;
    border-radius: 100%;
    z-index: 10;
    position: relative;
  }
.range::-webkit-slider-thumb:hover {
    background: #F2FAE6;
    background: var(--color-primary-50, #F2FAE6);
  }
.range::-webkit-slider-thumb:active {
    background: #5D9922;
  }
.range:focus-visible::-webkit-slider-thumb {
    background: #5D9922;
    border-color: white;
  }
.post-item {
    /** main */
  }
.post-item:focus-visible {
    box-shadow: 4px -4px 0px #F2FAE6, -4px -4px 0px #F2FAE6, -4px 4px 0px #F2FAE6, 4px 4px 0px #F2FAE6;
    outline: none;
  }
.post-item {
    /** title */
  }
.post-item:hover .post-item__title {
  --tw-text-opacity: 1;
  color: rgba(93, 153, 34, 1);
  color: rgba(93, 153, 34, var(--tw-text-opacity));
}
.button-special {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  border-radius: 4px;
  background-image: linear-gradient(to right, #F2AA18 var(--tw-gradient-from-position), #F26A3D var(--tw-gradient-to-position));
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
  --tw-gradient-from: #F2AA18 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(242, 170, 24, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
  --tw-gradient-to: #F26A3D var(--tw-gradient-to-position);
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, 1);
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}
.button-special:hover {
  --tw-gradient-from: #ED8B18 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(237, 139, 24, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
  --tw-gradient-to: #E75845 var(--tw-gradient-to-position);
}
.button-special:focus {
  --tw-gradient-from: #E2800D var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(226, 128, 13, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
  --tw-gradient-to: #E54B36 var(--tw-gradient-to-position);
}
.button-special:focus-visible {
  --tw-gradient-from: #F2AA18 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(242, 170, 24, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
  --tw-gradient-to: #F26A3D var(--tw-gradient-to-position);
    box-shadow: 4px -4px 0px #FFDFC9, -4px -4px 0px #FFDFC9, -4px 4px 0px #FFDFC9, 4px 4px 0px #FFDFC9;
    outline: none;
}
.focus-shadow:focus-visible {
    box-shadow: 4px -4px 0px #F2FAE6, -4px -4px 0px #F2FAE6, -4px 4px 0px #F2FAE6, 4px 4px 0px #F2FAE6;
    outline: none;
  }
.focus-outline:focus-visible {
    outline: 4px solid #F2FAE6;
  }
.focus-background:focus-visible {
  border-radius: 1rem;
  --tw-bg-opacity: 1;
  background-color: rgba(242, 250, 230, 1);
  background-color: rgba(242, 250, 230, var(--tw-bg-opacity));
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.flex-block {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
}
.clickable {
  cursor: pointer;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
  white-space: nowrap;
}
.header-overlay {
    background-color: rgba(0, 0, 0, 0.8);
    position: fixed;
    top: 0px;
    right: 0px;
    bottom: 0px;
    left: 0px;
    z-index: 40;
    display: none;
    opacity: 0;
    transition-property: opacity;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms;
  }
.header-menu--open + .header-overlay {
    display: block;
    opacity: 1;
  }
.header-menu {
  visibility: hidden;
  position: absolute;
  left: 0px;
  bottom: 0px;
  top: 0px;
  z-index: 50;
  height: 100vh;
  width: 250px;
  --tw-translate-x: -100%;
  transform: translate(-100%, var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, 1);
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.footer-section {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}
@media (min-width: 1184px) {

  .footer-section {
    width: 368px;
  }
}
.no-scrollbar {
  -ms-overflow-style: none;
  scrollbar-width: none;
}
.no-scrollbar::-webkit-scrollbar {
  display: none;
}
.shadow-t {
    box-shadow: 0px 0px 8px rgba(61, 61, 61, 0.12), 0px 2px 4px rgba(61, 61, 61, 0.06);
  }
.\\!visible {
  visibility: visible !important;
}
.invisible {
  visibility: hidden;
}
.static {
  position: static;
}
.fixed {
  position: fixed;
}
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.inset-0 {
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
}
.bottom-0 {
  bottom: 0px;
}
.left-0 {
  left: 0px;
}
.right-0 {
  right: 0px;
}
.top-0 {
  top: 0px;
}
.top-1\\/2 {
  top: 50%;
}
.z-0 {
  z-index: 0;
}
.z-10 {
  z-index: 10;
}
.z-40 {
  z-index: 40;
}
.z-50 {
  z-index: 50;
}
.mb-2 {
  margin-bottom: 0.5rem;
}
.mb-4 {
  margin-bottom: 1rem;
}
.mb-6 {
  margin-bottom: 1.5rem;
}
.mb-\\[48px\\] {
  margin-bottom: 48px;
}
.mr-2 {
  margin-right: 0.5rem;
}
.mt-1 {
  margin-top: 0.25rem;
}
.mt-12 {
  margin-top: 3rem;
}
.mt-4 {
  margin-top: 1rem;
}
.mt-5 {
  margin-top: 1.25rem;
}
.mt-8 {
  margin-top: 2rem;
}
.mt-\\[10px\\] {
  margin-top: 10px;
}
.block {
  display: block;
}
.inline {
  display: inline;
}
.flex {
  display: flex;
}
.inline-flex {
  display: inline-flex;
}
.table {
  display: table;
}
.contents {
  display: contents;
}
.hidden {
  display: none;
}
.aspect-square {
  aspect-ratio: 1 / 1;
}
.aspect-video {
  aspect-ratio: 16 / 9;
}
.h-\\[26px\\] {
  height: 26px;
}
.h-\\[3px\\] {
  height: 3px;
}
.h-\\[48px\\] {
  height: 48px;
}
.h-\\[65px\\] {
  height: 65px;
}
.h-full {
  height: 100%;
}
.min-h-\\[120px\\] {
  min-height: 120px;
}
.w-10 {
  width: 2.5rem;
}
.w-12 {
  width: 3rem;
}
.w-2 {
  width: 0.5rem;
}
.w-3 {
  width: 0.75rem;
}
.w-6 {
  width: 1.5rem;
}
.w-60 {
  width: 15rem;
}
.w-\\[18px\\] {
  width: 18px;
}
.w-\\[240px\\] {
  width: 240px;
}
.w-\\[2px\\] {
  width: 2px;
}
.w-\\[67px\\] {
  width: 67px;
}
.w-\\[85\\%\\] {
  width: 85%;
}
.w-full {
  width: 100%;
}
.max-w-\\[113px\\] {
  max-width: 113px;
}
.max-w-\\[776px\\] {
  max-width: 776px;
}
.flex-1 {
  flex: 1 1 0%;
}
.flex-\\[0_0_auto\\] {
  flex: 0 0 auto;
}
.origin-center {
  transform-origin: center;
}
.-translate-x-1 {
  --tw-translate-x: -0.25rem;
  transform: translate(-0.25rem, var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-x-14 {
  --tw-translate-x: -3.5rem;
  transform: translate(-3.5rem, var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-14 {
  --tw-translate-x: 3.5rem;
  transform: translate(3.5rem, var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-1\\/2 {
  --tw-translate-y: 50%;
  transform: translate(var(--tw-translate-x), 50%) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-\\[2px\\] {
  --tw-translate-y: 2px;
  transform: translate(var(--tw-translate-x), 2px) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-rotate-90 {
  --tw-rotate: -90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(-90deg) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-180 {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(180deg) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-90 {
  --tw-rotate: 90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(90deg) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.resize {
  resize: both;
}
.snap-x {
  scroll-snap-type: x var(--tw-scroll-snap-strictness);
}
.snap-proximity {
  --tw-scroll-snap-strictness: proximity;
}
.snap-center {
  scroll-snap-align: center;
}
.grid-cols-3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.grid-cols-4 {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}
.flex-row {
  flex-direction: row;
}
.flex-row-reverse {
  flex-direction: row-reverse;
}
.flex-wrap {
  flex-wrap: wrap;
}
.content-start {
  align-content: flex-start;
}
.items-start {
  align-items: flex-start;
}
.items-end {
  align-items: flex-end;
}
.items-center {
  align-items: center;
}
.justify-start {
  justify-content: flex-start;
}
.justify-end {
  justify-content: flex-end;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.justify-stretch {
  justify-content: stretch;
}
.gap-1 {
  gap: 0.25rem;
}
.gap-2 {
  gap: 0.5rem;
}
.gap-3 {
  gap: 0.75rem;
}
.gap-4 {
  gap: 1rem;
}
.gap-6 {
  gap: 1.5rem;
}
.gap-\\[6px\\] {
  gap: 6px;
}
.gap-x-10 {
  -moz-column-gap: 2.5rem;
       column-gap: 2.5rem;
}
.gap-y-1 {
  row-gap: 0.25rem;
}
.gap-y-6 {
  row-gap: 1.5rem;
}
.self-end {
  align-self: flex-end;
}
.overflow-hidden {
  overflow: hidden;
}
.overflow-x-auto {
  overflow-x: auto;
}
.overflow-x-hidden {
  overflow-x: hidden;
}
.overflow-x-scroll {
  overflow-x: scroll;
}
.whitespace-normal {
  white-space: normal;
}
.whitespace-nowrap {
  white-space: nowrap;
}
.rounded-\\[4px\\] {
  border-radius: 4px;
}
.rounded-full {
  border-radius: 9999px;
}
.rounded-lg {
  border-radius: 0.5rem;
}
.rounded-md {
  border-radius: 0.375rem;
}
.border {
  border-width: 1px;
}
.border-2 {
  border-width: 2px;
}
.border-b-2 {
  border-bottom-width: 2px;
}
.border-t {
  border-top-width: 1px;
}
.border-solid {
  border-style: solid;
}
.border-\\[\\#E0E0E0\\] {
  --tw-border-opacity: 1;
  border-color: rgba(224, 224, 224, 1);
  border-color: rgba(224, 224, 224, var(--tw-border-opacity));
}
.border-\\[\\#c4c4c4\\] {
  --tw-border-opacity: 1;
  border-color: rgba(196, 196, 196, 1);
  border-color: rgba(196, 196, 196, var(--tw-border-opacity));
}
.border-neutral-200 {
  --tw-border-opacity: 1;
  border-color: rgba(245, 245, 245, 1);
  border-color: rgba(245, 245, 245, var(--tw-border-opacity));
}
.border-neutral-300 {
  --tw-border-opacity: 1;
  border-color: rgba(235, 235, 235, 1);
  border-color: rgba(235, 235, 235, var(--tw-border-opacity));
}
.border-primary-500 {
  --tw-border-opacity: 1;
  border-color: rgba(93, 153, 34, 1);
  border-color: rgba(93, 153, 34, var(--tw-border-opacity));
}
.border-white {
  --tw-border-opacity: 1;
  border-color: rgba(255, 255, 255, 1);
  border-color: rgba(255, 255, 255, var(--tw-border-opacity));
}
.bg-neutral-100 {
  --tw-bg-opacity: 1;
  background-color: rgba(250, 250, 250, 1);
  background-color: rgba(250, 250, 250, var(--tw-bg-opacity));
}
.bg-neutral-200 {
  --tw-bg-opacity: 1;
  background-color: rgba(245, 245, 245, 1);
  background-color: rgba(245, 245, 245, var(--tw-bg-opacity));
}
.bg-neutral-300 {
  --tw-bg-opacity: 1;
  background-color: rgba(235, 235, 235, 1);
  background-color: rgba(235, 235, 235, var(--tw-bg-opacity));
}
.bg-primary-500 {
  --tw-bg-opacity: 1;
  background-color: rgba(93, 153, 34, 1);
  background-color: rgba(93, 153, 34, var(--tw-bg-opacity));
}
.bg-success-50 {
  --tw-bg-opacity: 1;
  background-color: rgba(240, 255, 246, 1);
  background-color: rgba(240, 255, 246, var(--tw-bg-opacity));
}
.bg-transparent {
  background-color: transparent;
}
.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, 1);
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
}
.bg-gradient-to-b {
  background-image: linear-gradient(to bottom, var(--tw-gradient-stops));
}
.bg-gradient-to-r {
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
}
.from-\\[\\#6BB248\\] {
  --tw-gradient-from: #6BB248 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(107, 178, 72, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#6bb24826\\] {
  --tw-gradient-from: rgba(107,178,72,0.14902) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(107, 178, 72, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#8ECC3D\\] {
  --tw-gradient-from: #8ECC3D var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(142, 204, 61, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#F5F5F5\\] {
  --tw-gradient-from: #F5F5F5 var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(245, 245, 245, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.to-\\[\\#36B242\\] {
  --tw-gradient-to: #36B242 var(--tw-gradient-to-position);
}
.to-\\[\\#47B28F\\] {
  --tw-gradient-to: #47B28F var(--tw-gradient-to-position);
}
.to-\\[\\#47b28f26\\] {
  --tw-gradient-to: rgba(71,178,143,0.14902) var(--tw-gradient-to-position);
}
.to-\\[\\#EBEBEB\\] {
  --tw-gradient-to: #EBEBEB var(--tw-gradient-to-position);
}
.bg-\\[length\\:24px\\] {
  background-size: 24px;
}
.bg-cover {
  background-size: cover;
}
.bg-clip-text {
  -webkit-background-clip: text;
          background-clip: text;
}
.bg-center {
  background-position: center;
}
.bg-no-repeat {
  background-repeat: no-repeat;
}
.fill-neutral-700 {
  fill: #8A8A8A;
}
.object-cover {
  -o-object-fit: cover;
     object-fit: cover;
}
.p-1 {
  padding: 0.25rem;
}
.p-4 {
  padding: 1rem;
}
.px-1 {
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-\\[1px\\] {
  padding-left: 1px;
  padding-right: 1px;
}
.py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-6 {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.py-7 {
  padding-top: 1.75rem;
  padding-bottom: 1.75rem;
}
.py-\\[11px\\] {
  padding-top: 11px;
  padding-bottom: 11px;
}
.py-\\[1px\\] {
  padding-top: 1px;
  padding-bottom: 1px;
}
.py-\\[24px\\] {
  padding-top: 24px;
  padding-bottom: 24px;
}
.pb-0 {
  padding-bottom: 0px;
}
.pb-1 {
  padding-bottom: 0.25rem;
}
.pb-10 {
  padding-bottom: 2.5rem;
}
.pb-2 {
  padding-bottom: 0.5rem;
}
.pb-6 {
  padding-bottom: 1.5rem;
}
.pb-\\[10px\\] {
  padding-bottom: 10px;
}
.pb-\\[14px\\] {
  padding-bottom: 14px;
}
.pb-\\[24px\\] {
  padding-bottom: 24px;
}
.pl-0 {
  padding-left: 0px;
}
.pl-4 {
  padding-left: 1rem;
}
.pr-2 {
  padding-right: 0.5rem;
}
.pt-4 {
  padding-top: 1rem;
}
.align-middle {
  vertical-align: middle;
}
.text-2xl {
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-\\[28px\\] {
  font-size: 28px;
}
.text-lg {
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xs {
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-bold {
  font-weight: 700;
}
.font-semibold {
  font-weight: 600;
}
.lowercase {
  text-transform: lowercase;
}
.\\!leading-none {
  line-height: 1 !important;
}
.leading-7 {
  line-height: 1.75rem;
}
.leading-8 {
  line-height: 2rem;
}
.leading-\\[35px\\] {
  line-height: 35px;
}
.leading-normal {
  line-height: 1.5;
}
.text-neutral-700 {
  --tw-text-opacity: 1;
  color: rgba(138, 138, 138, 1);
  color: rgba(138, 138, 138, var(--tw-text-opacity));
}
.text-neutral-800 {
  --tw-text-opacity: 1;
  color: rgba(107, 107, 107, 1);
  color: rgba(107, 107, 107, var(--tw-text-opacity));
}
.text-neutral-900 {
  --tw-text-opacity: 1;
  color: rgba(61, 61, 61, 1);
  color: rgba(61, 61, 61, var(--tw-text-opacity));
}
.text-primary-500 {
  --tw-text-opacity: 1;
  color: rgba(93, 153, 34, 1);
  color: rgba(93, 153, 34, var(--tw-text-opacity));
}
.text-success-600 {
  --tw-text-opacity: 1;
  color: rgba(72, 121, 79, 1);
  color: rgba(72, 121, 79, var(--tw-text-opacity));
}
.text-transparent {
  color: transparent;
}
.text-white {
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, 1);
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}
.underline {
  text-decoration-line: underline;
}
.opacity-0 {
  opacity: 0;
}
.opacity-100 {
  opacity: 1;
}
.shadow {
  --tw-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px -1px rgba(0, 0, 0, 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px -1px rgba(0, 0, 0, 0.1);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow);
}
.shadow-lg {
  --tw-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: 0 0 rgba(0,0,0,0), 0 0 rgba(0,0,0,0), 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 rgba(0,0,0,0)), var(--tw-ring-shadow, 0 0 rgba(0,0,0,0)), var(--tw-shadow);
}
.outline-none {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.outline {
  outline-style: solid;
}
.outline-1 {
  outline-width: 1px;
}
.outline-primary-500 {
  outline-color: #5D9922;
}
.transition-opacity {
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-transform {
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-700 {
  transition-duration: 700ms;
}
/* cyrillic-ext */
@font-face {
  font-family: "Noto Sans Display";
  font-style: normal;
  font-weight: 400;
  font-stretch: 100%;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/notosansdisplay/v26/RLpWK4fy6r6tOBEJg0IAKzqdFZVZxpMkXJMhnB9XjO1o90LEVssiCKY.woff2) format("woff2");
  unicode-range: U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F;
}
/* cyrillic */
@font-face {
  font-family: "Noto Sans Display";
  font-style: normal;
  font-weight: 400;
  font-stretch: 100%;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/notosansdisplay/v26/RLpWK4fy6r6tOBEJg0IAKzqdFZVZxpMkXJMhnB9XjO1o90LEX8siCKY.woff2) format("woff2");
  unicode-range: U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;
}
/* greek-ext */
@font-face {
  font-family: "Noto Sans Display";
  font-style: normal;
  font-weight: 400;
  font-stretch: 100%;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/notosansdisplay/v26/RLpWK4fy6r6tOBEJg0IAKzqdFZVZxpMkXJMhnB9XjO1o90LEV8siCKY.woff2) format("woff2");
  unicode-range: U+1F00-1FFF;
}
/* greek */
@font-face {
  font-family: "Noto Sans Display";
  font-style: normal;
  font-weight: 400;
  font-stretch: 100%;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/notosansdisplay/v26/RLpWK4fy6r6tOBEJg0IAKzqdFZVZxpMkXJMhnB9XjO1o90LEWMsiCKY.woff2) format("woff2");
  unicode-range: U+0370-03FF;
}
/* vietnamese */
@font-face {
  font-family: "Noto Sans Display";
  font-style: normal;
  font-weight: 400;
  font-stretch: 100%;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/notosansdisplay/v26/RLpWK4fy6r6tOBEJg0IAKzqdFZVZxpMkXJMhnB9XjO1o90LEVMsiCKY.woff2) format("woff2");
  unicode-range: U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+0300-0301, U+0303-0304, U+0308-0309, U+0323, U+0329, U+1EA0-1EF9, U+20AB;
}
/* latin-ext */
@font-face {
  font-family: "Noto Sans Display";
  font-style: normal;
  font-weight: 400;
  font-stretch: 100%;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/notosansdisplay/v26/RLpWK4fy6r6tOBEJg0IAKzqdFZVZxpMkXJMhnB9XjO1o90LEVcsiCKY.woff2) format("woff2");
  unicode-range: U+0100-02AF, U+0304, U+0308, U+0329, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
}
/* latin */
@font-face {
  font-family: "Noto Sans Display";
  font-style: normal;
  font-weight: 400;
  font-stretch: 100%;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/notosansdisplay/v26/RLpWK4fy6r6tOBEJg0IAKzqdFZVZxpMkXJMhnB9XjO1o90LEW8si.woff2) format("woff2");
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}
/* cyrillic-ext */
@font-face {
  font-family: "Noto Sans Display";
  font-style: normal;
  font-weight: 600;
  font-stretch: 100%;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/notosansdisplay/v26/RLpWK4fy6r6tOBEJg0IAKzqdFZVZxpMkXJMhnB9XjO1o90LEVssiCKY.woff2) format("woff2");
  unicode-range: U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F;
}
/* cyrillic */
@font-face {
  font-family: "Noto Sans Display";
  font-style: normal;
  font-weight: 600;
  font-stretch: 100%;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/notosansdisplay/v26/RLpWK4fy6r6tOBEJg0IAKzqdFZVZxpMkXJMhnB9XjO1o90LEX8siCKY.woff2) format("woff2");
  unicode-range: U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;
}
/* greek-ext */
@font-face {
  font-family: "Noto Sans Display";
  font-style: normal;
  font-weight: 600;
  font-stretch: 100%;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/notosansdisplay/v26/RLpWK4fy6r6tOBEJg0IAKzqdFZVZxpMkXJMhnB9XjO1o90LEV8siCKY.woff2) format("woff2");
  unicode-range: U+1F00-1FFF;
}
/* greek */
@font-face {
  font-family: "Noto Sans Display";
  font-style: normal;
  font-weight: 600;
  font-stretch: 100%;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/notosansdisplay/v26/RLpWK4fy6r6tOBEJg0IAKzqdFZVZxpMkXJMhnB9XjO1o90LEWMsiCKY.woff2) format("woff2");
  unicode-range: U+0370-03FF;
}
/* vietnamese */
@font-face {
  font-family: "Noto Sans Display";
  font-style: normal;
  font-weight: 600;
  font-stretch: 100%;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/notosansdisplay/v26/RLpWK4fy6r6tOBEJg0IAKzqdFZVZxpMkXJMhnB9XjO1o90LEVMsiCKY.woff2) format("woff2");
  unicode-range: U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+0300-0301, U+0303-0304, U+0308-0309, U+0323, U+0329, U+1EA0-1EF9, U+20AB;
}
/* latin-ext */
@font-face {
  font-family: "Noto Sans Display";
  font-style: normal;
  font-weight: 600;
  font-stretch: 100%;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/notosansdisplay/v26/RLpWK4fy6r6tOBEJg0IAKzqdFZVZxpMkXJMhnB9XjO1o90LEVcsiCKY.woff2) format("woff2");
  unicode-range: U+0100-02AF, U+0304, U+0308, U+0329, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
}
/* latin */
@font-face {
  font-family: "Noto Sans Display";
  font-style: normal;
  font-weight: 600;
  font-stretch: 100%;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/notosansdisplay/v26/RLpWK4fy6r6tOBEJg0IAKzqdFZVZxpMkXJMhnB9XjO1o90LEW8si.woff2) format("woff2");
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}
/* cyrillic-ext */
@font-face {
  font-family: "Raleway";
  font-style: italic;
  font-weight: 100 900;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/raleway/v29/1Ptsg8zYS_SKggPNyCg4QIFqPfE.woff2) format("woff2");
  unicode-range: U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F;
}
/* cyrillic */
@font-face {
  font-family: "Raleway";
  font-style: italic;
  font-weight: 100 900;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/raleway/v29/1Ptsg8zYS_SKggPNyCg4SYFqPfE.woff2) format("woff2");
  unicode-range: U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;
}
/* vietnamese */
@font-face {
  font-family: "Raleway";
  font-style: italic;
  font-weight: 100 900;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/raleway/v29/1Ptsg8zYS_SKggPNyCg4QoFqPfE.woff2) format("woff2");
  unicode-range: U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+0300-0301, U+0303-0304, U+0308-0309, U+0323, U+0329, U+1EA0-1EF9, U+20AB;
}
/* latin-ext */
@font-face {
  font-family: "Raleway";
  font-style: italic;
  font-weight: 100 900;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/raleway/v29/1Ptsg8zYS_SKggPNyCg4Q4FqPfE.woff2) format("woff2");
  unicode-range: U+0100-02AF, U+0304, U+0308, U+0329, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
}
/* latin */
@font-face {
  font-family: "Raleway";
  font-style: italic;
  font-weight: 100 900;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/raleway/v29/1Ptsg8zYS_SKggPNyCg4TYFq.woff2) format("woff2");
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}
/* cyrillic-ext */
@font-face {
  font-family: "Raleway";
  font-style: normal;
  font-weight: 100 900;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/raleway/v29/1Ptug8zYS_SKggPNyCAIT5lu.woff2) format("woff2");
  unicode-range: U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F;
}
/* cyrillic */
@font-face {
  font-family: "Raleway";
  font-style: normal;
  font-weight: 100 900;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/raleway/v29/1Ptug8zYS_SKggPNyCkIT5lu.woff2) format("woff2");
  unicode-range: U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;
}
/* vietnamese */
@font-face {
  font-family: "Raleway";
  font-style: normal;
  font-weight: 100 900;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/raleway/v29/1Ptug8zYS_SKggPNyCIIT5lu.woff2) format("woff2");
  unicode-range: U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+0300-0301, U+0303-0304, U+0308-0309, U+0323, U+0329, U+1EA0-1EF9, U+20AB;
}
/* latin-ext */
@font-face {
  font-family: "Raleway";
  font-style: normal;
  font-weight: 100 900;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/raleway/v29/1Ptug8zYS_SKggPNyCMIT5lu.woff2) format("woff2");
  unicode-range: U+0100-02AF, U+0304, U+0308, U+0329, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
}
/* latin */
@font-face {
  font-family: "Raleway";
  font-style: normal;
  font-weight: 100 900;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/raleway/v29/1Ptug8zYS_SKggPNyC0ITw.woff2) format("woff2");
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}
h1 {
  font-family: Raleway;
  font-style: normal;
  font-weight: 700;
}

.title1 {
  font-size: 28px;
  line-height: 35px;
}

h2, .title2 {
  font-feature-settings: lining-nums proportional-nums;
  font-variant-numeric: lining-nums proportional-nums;
  font-family: Raleway;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 30px;
  letter-spacing: 0.1px;
}

h3, .title3 {
  font-feature-settings: lining-nums proportional-nums;
  font-variant-numeric: lining-nums proportional-nums;
  font-family: Raleway;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 25px;
  letter-spacing: 0.1px;
}

h4, .title4 {
  font-feature-settings: lining-nums proportional-nums;
  font-variant-numeric: lining-nums proportional-nums;
  font-family: Raleway;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 22.5px;
  letter-spacing: 0.1px;
}

h5, .title5 {
  font-feature-settings: lining-nums proportional-nums;
  font-variant-numeric: lining-nums proportional-nums;
  font-family: Raleway;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px;
  letter-spacing: 0.1px;
}

h6, .title6 {
  font-feature-settings: lining-nums proportional-nums;
  font-variant-numeric: lining-nums proportional-nums;
  font-family: Raleway;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 17.5px;
  letter-spacing: 0.1px;
}

@media all and (min-width: 776px) {
  .title1 {
    font-size: 40px;
    line-height: 50px;
  }
  h2, .title2 {
    font-size: 32px;
    line-height: 40px;
  }
  h3, .title3 {
    font-size: 34px;
    line-height: 30px;
  }
  h4, .title4 {
    font-size: 20px;
    line-height: 25px;
  }
  h6, .title6 {
    font-feature-settings: lining-nums proportional-nums;
    font-variant-numeric: lining-nums proportional-nums;
    font-family: Raleway;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 20px;
    letter-spacing: 0.1px;
  }
}
.post-default-background {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
}

.post-topline-background {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
  background-position: center right;
  background-repeat: no-repeat;
}

.post-lime-background {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_17___});
  background-position: center right;
  background-repeat: no-repeat;
}

.lime-logo {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
  background-repeat: no-repeat;
  background-size: contain;
}

.content {
  width: 100%;
  color: #3D3D3D;
  color: var(--color-neutral-900, #3D3D3D);
}
.content a {
  color: #5D9922;
  color: var(--color-primary-500, #5D9922);
}
.content a:hover {
  -webkit-text-decoration: underline;
  text-decoration: underline;
}
.content a:focus-visible {
  background-color: #F2FAE6;
  background-color: var(--color-primary-50, #F2FAE6);
  outline: none;
}
.content a:disabled {
  color: #B0B0B0;
  color: var(--color-neutral-600, #B0B0B0);
}
.content > p, .content > ul, .content > div, .content > ol, .content > figure {
  margin-bottom: 24px;
}
.content h1 {
  font-size: 40px;
  line-height: 50px;
}
.content h2, .content h3, .content h4, .content h5, .content h6 {
  margin-bottom: 8px;
}
.content h2, .content .title2 {
  color: #3D3D3D;
  color: var(--Neutral-900, #3D3D3D);
}
.content figure img {
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #EBEBEB;
  border: 1px solid var(--Neutral-300, #EBEBEB);
  width: 100% !important;
  -o-object-fit: cover;
     object-fit: cover;
}
.content > figure {
  margin-top: 40px;
}
.content img[data-src] {
  background-color: #F5F5F5;
  aspect-ratio: 16/9;
}
.content img[data-src].aspect-square {
  aspect-ratio: 1/1;
}
.content br {
  display: block;
  content: "";
  margin-bottom: 20px;
}
.content .wp-block-gallery {
  display: flex;
  width: 100%;
  gap: 0.5rem;
  transition: transform 0.5s ease;
}
.content .wp-block-gallery .wp-block-image {
  display: flex;
  flex: 0 0 85%;
}
.content .wp-block-gallery-stick {
  display: none;
}
@media all and (min-width: 776px) {
  .content .wp-block-gallery {
    gap: 0;
  }
  .content .wp-block-gallery .wp-block-image {
    flex: 0 0 100%;
  }
  .content .wp-block-gallery-stick {
    content: "";
    position: absolute;
    display: block;
    top: 50%;
    transform: translateY(-50%);
    width: 48px;
    aspect-ratio: 1/1;
    cursor: pointer;
    -webkit-user-select: none;
       -moz-user-select: none;
            user-select: none;
    z-index: 10;
    background-position: center center;
    background-size: 24px;
    transform-origin: center center;
  }
  .content .wp-block-gallery-stick:hover {
    background-size: 48px 48px;
  }
  .content .wp-block-gallery-stick--left {
    left: 15px;
  }
  .content .wp-block-gallery-stick--right {
    right: 15px;
    transform: translateY(-50%) rotate(180deg);
  }
}

.no-scroll {
  height: 100%;
  overflow: hidden;
  width: 100%;
  position: fixed;
}

.rate__item {
  transition: 0.15s ease transform;
}
.rate__item:hover, .rate__item:hover ~ .rate__item {
    --icon: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
  }

.ya-share2 .ya-share2__popup > .ya-share2__list {
  background: #FFFFFF;
  box-shadow: 0px 0px 16px rgba(61, 61, 61, 0.12), 0px 4px 8px rgba(61, 61, 61, 0.06);
  border-radius: 4px;
  z-index: 7;
  display: none;
  flex-direction: column;
  align-items: flex-start;
  padding: 4px 0px;
  max-width: 362px;
  width: 100%;
  position: absolute;
  left: 0;
  top: 0;
  color: #3D3D3D;
  color: var(--color-neutral-900, #3D3D3D);
}
.ya-share2 .ya-share2__popup > .ya-share2__list .ya-share2__item {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  width: 100%;
}
.ya-share2 .ya-share2__popup > .ya-share2__list .ya-share2__link {
  width: 100%;
  display: flex;
  gap: 8px;
  padding: 8px 16px;
  align-items: center;
}
.ya-share2 .ya-share2__popup > .ya-share2__list .ya-share2__title {
  font-family: "Raleway";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.01em;
}
.ya-share2 .ya-share2__popup > .ya-share2__list .ya-share2__link:hover {
  background-color: #f5f5f5;
  background-color: var(--color-neutral-100, #f5f5f5);
}
.ya-share2 .ya-share2__popup > .ya-share2__list .ya-share2__link:focus {
  background-color: #fff;
}
.ya-share2 .ya-share2__popup > .ya-share2__list .ya-share2__icon {
  width: 24px;
  aspect-ratio: 1/1;
}
.ya-share2 .ya-share2__popup > .ya-share2__list .ya-share2__item_copy .ya-share2__icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_20___});
}
.ya-share2 .ya-share2__popup > .ya-share2__list .ya-share2__item_service_vkontakte .ya-share2__icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_21___});
}
.ya-share2 .ya-share2__popup > .ya-share2__list .ya-share2__item_service_odnoklassniki .ya-share2__icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_22___});
}
.ya-share2 .ya-share2__popup > .ya-share2__list .ya-share2__item_service_telegram .ya-share2__icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_23___});
}
.ya-share2 .ya-share2__popup > .ya-share2__list .ya-share2__item_service_whatsapp .ya-share2__icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_24___});
}

.ya-share2 .ya-share2__popup.ya-share2__popup_visible > .ya-share2__list {
  display: flex;
}

.ya-share2__input_copy {
  display: none;
}

body {
  font-family: "Noto Sans Display";
  font-size: 16px;
  font-style: normal;
  line-height: 150%;
  letter-spacing: 0.16px;
  visibility: visible !important;
}

[data-edit] {
  position: relative;
}
[data-edit][data-empty]:before {
  min-width: 1rem;
  min-height: 1rem;
  content: "";
  display: inline-block;
}
[data-edit] .customize-partial-edit-shortcut {
  left: 0;
  top: 0;
  transform: translateX(-100%) !important;
}

.customize-partial-edit-shortcut-button {
  opacity: 0.1 !important;
}
.customize-partial-edit-shortcut-button:hover {
  opacity: 1 !important;
}

.tablet-w-50 {
  width: 100%;
}

@media all and (min-width: 768px) and (max-width: 1184px) {
  .mobile\\:flex-nowrap {
    flex-wrap: wrap !important;
  }
  .tablet-w-50 {
    width: 50%;
  }
  .tablet-w-50 + .tablet-w-50 {
    padding-left: 1rem;
  }
  .tablet-w-100 {
    width: 100%;
  }
}

@media (max-width: 1183px) {
  .mobile\\:clickable {
    cursor: pointer;
    -webkit-user-select: none;
       -moz-user-select: none;
            user-select: none;
    white-space: nowrap;
  }
  .mobile\\:\\!header-menu--open + .header-overlay {
    display: block;
    opacity: 1;
  }
  .mobile\\:header-menu {
    visibility: hidden;
    position: absolute;
    left: 0px;
    bottom: 0px;
    top: 0px;
    z-index: 50;
    height: 100vh;
    width: 250px;
    --tw-translate-x: -100%;
    transform: translate(-100%, var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
    --tw-bg-opacity: 1;
    background-color: rgba(255, 255, 255, 1);
    background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
    transition-property: transform;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms;
  }
  .mobile\\:\\!header-menu--open {
    transform: translateX(0) !important;
  }
}

@media (min-width: 1184px) {
  .desktop\\:header-menu-inline {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
    margin-right: 0.5rem;
    flex: 1 1 auto;
  }
}

.hover\\:fill-neutral-800:hover {
  fill: #6B6B6B;
}

.focus-visible\\:rounded:focus-visible {
  border-radius: 0.25rem;
}

.data-\\[fixed\\]\\:block[data-fixed] {
  display: block;
}

.data-\\[active\\=\\'1\\'\\]\\:border-primary-500[data-active='1'] {
  --tw-border-opacity: 1;
  border-color: rgba(93, 153, 34, 1);
  border-color: rgba(93, 153, 34, var(--tw-border-opacity));
}

.data-\\[active\\=\\'1\\'\\]\\:bg-primary-500[data-active='1'] {
  --tw-bg-opacity: 1;
  background-color: rgba(93, 153, 34, 1);
  background-color: rgba(93, 153, 34, var(--tw-bg-opacity));
}

.data-\\[active\\=\\'1\\'\\]\\:bg-white[data-active='1'] {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, 1);
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
}

.data-\\[active\\=\\'1\\'\\]\\:outline[data-active='1'] {
  outline-style: solid;
}

.group[data-loading] .group-data-\\[loading\\]\\:visible {
  visibility: visible;
}

.group[data-loading] .group-data-\\[loading\\]\\:hidden {
  display: none;
}

@keyframes spin {

  to {
    transform: rotate(360deg);
  }
}

.group[data-loading] .group-data-\\[loading\\]\\:animate-spin {
  animation: spin 1s linear infinite;
}

@media (max-width: 1183px) {

  .mobile\\:mt-4 {
    margin-top: 1rem;
  }

  .mobile\\:hidden {
    display: none;
  }

  .mobile\\:w-full {
    width: 100%;
  }

  .mobile\\:w-screen {
    width: 100vw;
  }

  .mobile\\:flex-\\[0_0_auto\\] {
    flex: 0 0 auto;
  }

  .mobile\\:flex-wrap {
    flex-wrap: wrap;
  }

  .mobile\\:flex-nowrap {
    flex-wrap: nowrap;
  }

  .mobile\\:gap-4 {
    gap: 1rem;
  }

  .mobile\\:bg-cover {
    background-size: cover;
  }

  .mobile\\:bg-center {
    background-position: center;
  }

  .mobile\\:text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }
}

@media (min-width: 1184px) {

  .desktop\\:sticky {
    position: sticky;
  }

  .desktop\\:top-28 {
    top: 7rem;
  }

  .desktop\\:order-1 {
    order: 1;
  }

  .desktop\\:mx-auto {
    margin-left: auto;
    margin-right: auto;
  }

  .desktop\\:mb-10 {
    margin-bottom: 2.5rem;
  }

  .desktop\\:mb-5 {
    margin-bottom: 1.25rem;
  }

  .desktop\\:mb-\\[90px\\] {
    margin-bottom: 90px;
  }

  .desktop\\:mt-10 {
    margin-top: 2.5rem;
  }

  .desktop\\:mt-3 {
    margin-top: 0.75rem;
  }

  .desktop\\:block {
    display: block;
  }

  .desktop\\:flex {
    display: flex;
  }

  .desktop\\:grid {
    display: grid;
  }

  .desktop\\:\\!hidden {
    display: none !important;
  }

  .desktop\\:hidden {
    display: none;
  }

  .desktop\\:h-1 {
    height: 0.25rem;
  }

  .desktop\\:h-\\[140px\\] {
    height: 140px;
  }

  .desktop\\:h-\\[420px\\] {
    height: 420px;
  }

  .desktop\\:h-\\[57px\\] {
    height: 57px;
  }

  .desktop\\:h-\\[90px\\] {
    height: 90px;
  }

  .desktop\\:w-1\\/2 {
    width: 50%;
  }

  .desktop\\:w-\\[155px\\] {
    width: 155px;
  }

  .desktop\\:w-\\[366px\\] {
    width: 366px;
  }

  .desktop\\:w-\\[368px\\] {
    width: 368px;
  }

  .desktop\\:w-\\[572px\\] {
    width: 572px;
  }

  .desktop\\:w-\\[776px\\] {
    width: 776px;
  }

  .desktop\\:max-w-\\[200px\\] {
    max-width: 200px;
  }

  .desktop\\:max-w-\\[584px\\] {
    max-width: 584px;
  }

  .desktop\\:max-w-\\[776px\\] {
    max-width: 776px;
  }

  .desktop\\:\\!translate-x-0 {
    --tw-translate-x: 0px !important;
    transform: translate(0px, var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
  }

  .desktop\\:-translate-y-1 {
    --tw-translate-y: -0.25rem;
    transform: translate(var(--tw-translate-x), -0.25rem) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }

  .desktop\\:translate-y-\\[2px\\] {
    --tw-translate-y: 2px;
    transform: translate(var(--tw-translate-x), 2px) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }

  .desktop\\:translate-y-\\[3px\\] {
    --tw-translate-y: 3px;
    transform: translate(var(--tw-translate-x), 3px) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }

  @keyframes pulse {

    50% {
      opacity: .5;
    }
  }

  .desktop\\:animate-pulse {
    animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
  }

  .desktop\\:flex-wrap {
    flex-wrap: wrap;
  }

  .desktop\\:gap-10 {
    gap: 2.5rem;
  }

  .desktop\\:gap-4 {
    gap: 1rem;
  }

  .desktop\\:gap-5 {
    gap: 1.25rem;
  }

  .desktop\\:gap-\\[60px\\] {
    gap: 60px;
  }

  .desktop\\:gap-\\[8px\\] {
    gap: 8px;
  }

  .desktop\\:gap-y-2 {
    row-gap: 0.5rem;
  }

  .desktop\\:overflow-hidden {
    overflow: hidden;
  }

  .desktop\\:overflow-x-auto {
    overflow-x: auto;
  }

  .desktop\\:overflow-x-hidden {
    overflow-x: hidden;
  }

  .desktop\\:overflow-x-visible {
    overflow-x: visible;
  }

  .desktop\\:border {
    border-width: 1px;
  }

  .desktop\\:border-none {
    border-style: none;
  }

  .desktop\\:bg-neutral-900 {
    --tw-bg-opacity: 1;
    background-color: rgba(61, 61, 61, 1);
    background-color: rgba(61, 61, 61, var(--tw-bg-opacity));
  }

  .desktop\\:bg-white {
    --tw-bg-opacity: 1;
    background-color: rgba(255, 255, 255, 1);
    background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
  }

  .desktop\\:bg-opacity-40 {
    --tw-bg-opacity: 0.4;
  }

  .desktop\\:p-0 {
    padding: 0px;
  }

  .desktop\\:px-0 {
    padding-left: 0px;
    padding-right: 0px;
  }

  .desktop\\:px-3 {
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }

  .desktop\\:py-1 {
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
  }

  .desktop\\:py-10 {
    padding-top: 2.5rem;
    padding-bottom: 2.5rem;
  }

  .desktop\\:py-12 {
    padding-top: 3rem;
    padding-bottom: 3rem;
  }

  .desktop\\:py-3 {
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }

  .desktop\\:py-6 {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }

  .desktop\\:py-8 {
    padding-top: 2rem;
    padding-bottom: 2rem;
  }

  .desktop\\:py-\\[11px\\] {
    padding-top: 11px;
    padding-bottom: 11px;
  }

  .desktop\\:py-\\[48px\\] {
    padding-top: 48px;
    padding-bottom: 48px;
  }

  .desktop\\:pb-10 {
    padding-bottom: 2.5rem;
  }

  .desktop\\:pb-2 {
    padding-bottom: 0.5rem;
  }

  .desktop\\:pb-5 {
    padding-bottom: 1.25rem;
  }

  .desktop\\:pb-8 {
    padding-bottom: 2rem;
  }

  .desktop\\:pb-\\[6px\\] {
    padding-bottom: 6px;
  }

  .desktop\\:pl-5 {
    padding-left: 1.25rem;
  }

  .desktop\\:pl-6 {
    padding-left: 1.5rem;
  }

  .desktop\\:pr-4 {
    padding-right: 1rem;
  }

  .desktop\\:pr-8 {
    padding-right: 2rem;
  }

  .desktop\\:pt-1 {
    padding-top: 0.25rem;
  }

  .desktop\\:pt-10 {
    padding-top: 2.5rem;
  }

  .desktop\\:pt-4 {
    padding-top: 1rem;
  }

  .desktop\\:pt-5 {
    padding-top: 1.25rem;
  }

  .desktop\\:pt-6 {
    padding-top: 1.5rem;
  }

  .desktop\\:pt-\\[18px\\] {
    padding-top: 18px;
  }

  .desktop\\:text-2xl {
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .desktop\\:text-\\[32px\\] {
    font-size: 32px;
  }

  .desktop\\:text-\\[40px\\] {
    font-size: 40px;
  }

  .desktop\\:text-lg {
    font-size: 1.125rem;
    line-height: 1.75rem;
  }

  .desktop\\:leading-10 {
    line-height: 2.5rem;
  }

  .desktop\\:leading-8 {
    line-height: 2rem;
  }

  .desktop\\:leading-\\[50px\\] {
    line-height: 50px;
  }

  .desktop\\:text-neutral-0 {
    --tw-text-opacity: 1;
    color: rgba(255, 255, 255, 1);
    color: rgba(255, 255, 255, var(--tw-text-opacity));
  }

  .desktop\\:text-neutral-300 {
    --tw-text-opacity: 1;
    color: rgba(235, 235, 235, 1);
    color: rgba(235, 235, 235, var(--tw-text-opacity));
  }

  .desktop\\:text-neutral-800 {
    --tw-text-opacity: 1;
    color: rgba(107, 107, 107, 1);
    color: rgba(107, 107, 107, var(--tw-text-opacity));
  }

  .desktop\\:text-neutral-900 {
    --tw-text-opacity: 1;
    color: rgba(61, 61, 61, 1);
    color: rgba(61, 61, 61, var(--tw-text-opacity));
  }
}`, "",{"version":3,"sources":["webpack://./node_modules/tailwindcss/base.css","webpack://./node_modules/tailwindcss/components.css","webpack://./src/styles/icons.scss","webpack://./src/styles/index.scss","webpack://./src/styles/range.scss","webpack://./src/styles/post.scss","webpack://./src/styles/button.scss","webpack://./src/styles/tailwind.scss","webpack://./node_modules/tailwindcss/utilities.css","webpack://./src/styles/fonts.scss","webpack://./src/styles/content.scss","webpack://./src/styles/rate.scss","webpack://./src/styles/share.scss"],"names":[],"mappings":"AAAA;;CAAA,CAAA;;;CAAA;;AAAA;;;EAAA,sBAAA,EAAA,MAAA;EAAA,eAAA,EAAA,MAAA;EAAA,mBAAA,EAAA,MAAA;EAAA,qBAAA,EAAA,MAAA;AAAA;;AAAA;;EAAA,gBAAA;AAAA;;AAAA;;;;;;;CAAA;;AAAA;EAAA,gBAAA,EAAA,MAAA;EAAA,8BAAA,EAAA,MAAA;EAAA,gBAAA,EAAA,MAAA;EAAA,cAAA;KAAA,WAAA,EAAA,MAAA;EAAA,wRAAA,EAAA,MAAA;EAAA,6BAAA,EAAA,MAAA;EAAA,+BAAA,EAAA,MAAA;AAAA;;AAAA;;;CAAA;;AAAA;EAAA,SAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;AAAA;;AAAA;;;;CAAA;;AAAA;EAAA,SAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;EAAA,qBAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,0BAAA;EAAA,yCAAA;UAAA,iCAAA;AAAA;;AAAA;;CAAA;;AAAA;;;;;;EAAA,kBAAA;EAAA,oBAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,cAAA;EAAA,wBAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,mBAAA;AAAA;;AAAA;;;CAAA;;AAAA;;;;EAAA,+GAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,cAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,cAAA;EAAA,cAAA;EAAA,kBAAA;EAAA,wBAAA;AAAA;;AAAA;EAAA,eAAA;AAAA;;AAAA;EAAA,WAAA;AAAA;;AAAA;;;;CAAA;;AAAA;EAAA,cAAA,EAAA,MAAA;EAAA,qBAAA,EAAA,MAAA;EAAA,yBAAA,EAAA,MAAA;AAAA;;AAAA;;;;CAAA;;AAAA;;;;;EAAA,oBAAA,EAAA,MAAA;EAAA,eAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;EAAA,SAAA,EAAA,MAAA;EAAA,UAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,oBAAA;AAAA;;AAAA;;;CAAA;;AAAA;;;;EAAA,0BAAA,EAAA,MAAA;EAAA,6BAAA,EAAA,MAAA;EAAA,sBAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,aAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,gBAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,wBAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,YAAA;AAAA;;AAAA;;;CAAA;;AAAA;EAAA,6BAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,wBAAA;AAAA;;AAAA;;;CAAA;;AAAA;EAAA,0BAAA,EAAA,MAAA;EAAA,aAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,kBAAA;AAAA;;AAAA;;CAAA;;AAAA;;;;;;;;;;;;;EAAA,SAAA;AAAA;;AAAA;EAAA,SAAA;EAAA,UAAA;AAAA;;AAAA;EAAA,UAAA;AAAA;;AAAA;;;EAAA,gBAAA;EAAA,SAAA;EAAA,UAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,gBAAA;AAAA;;AAAA;;;CAAA;;AAAA;EAAA,UAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;AAAA;;AAAA;;EAAA,UAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,eAAA;AAAA;;AAAA;;CAAA;AAAA;EAAA,eAAA;AAAA;;AAAA;;;;CAAA;;AAAA;;;;;;;;EAAA,cAAA,EAAA,MAAA;EAAA,sBAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,eAAA;EAAA,YAAA;AAAA;;AAAA,wEAAA;AAAA;EAAA,aAAA;AAAA;;AAAA;EAAA,wBAAA;EAAA,wBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,cAAA;EAAA,cAAA;EAAA,cAAA;EAAA,eAAA;EAAA,eAAA;EAAA,aAAA;EAAA,aAAA;EAAA,kBAAA;EAAA,sCAAA;EAAA,8BAAA;EAAA,6BAAA;EAAA,4BAAA;EAAA,eAAA;EAAA,oBAAA;EAAA,sBAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,kBAAA;EAAA,2BAAA;EAAA,4BAAA;EAAA,wCAAA;EAAA,0CAAA;EAAA,mCAAA;EAAA,8BAAA;EAAA,sCAAA;EAAA,YAAA;EAAA,kBAAA;EAAA,gBAAA;EAAA,iBAAA;EAAA,kBAAA;EAAA,cAAA;EAAA,gBAAA;EAAA,aAAA;EAAA,mBAAA;EAAA,qBAAA;EAAA,2BAAA;EAAA,yBAAA;EAAA,0BAAA;EAAA,2BAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,yBAAA;EAAA;AAAA;;AAAA;EAAA,wBAAA;EAAA,wBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,cAAA;EAAA,cAAA;EAAA,cAAA;EAAA,eAAA;EAAA,eAAA;EAAA,aAAA;EAAA,aAAA;EAAA,kBAAA;EAAA,sCAAA;EAAA,8BAAA;EAAA,6BAAA;EAAA,4BAAA;EAAA,eAAA;EAAA,oBAAA;EAAA,sBAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,kBAAA;EAAA,2BAAA;EAAA,4BAAA;EAAA,wCAAA;EAAA,0CAAA;EAAA,mCAAA;EAAA,8BAAA;EAAA,sCAAA;EAAA,YAAA;EAAA,kBAAA;EAAA,gBAAA;EAAA,iBAAA;EAAA,kBAAA;EAAA,cAAA;EAAA,gBAAA;EAAA,aAAA;EAAA,mBAAA;EAAA,qBAAA;EAAA,2BAAA;EAAA,yBAAA;EAAA,0BAAA;EAAA,2BAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,yBAAA;EAAA;AAAA;ACAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;;EAAA;IAAA;EAAA;;EAAA;IAAA;EAAA;AAAA;ACAA;IAII,0BAAA;IACA,4BAAA;IACA,cAAA;IACA,WAAA;ECEF;ADoBE;IAII,6BAAA;ECrBN;AD0BM;IAGI,yDAAA;EC1BV;ADuBM;IAGI,yDAAA;ECpBV;ADiBM;IAGI,yDAAA;ECdV;ADWM;IAGI,yDAAA;ECRV;ADKM;IAGI,yDAAA;ECFV;ADDM;IAGI,yDAAA;ECIV;ADPM;IAGI,yDAAA;ECUV;ADbM;IAGI,yDAAA;ECgBV;ADbM;IAEI,+CAAA;ECoBV;AD5BM;IAGI,yDAAA;ECkCV;ADrCM;IAGI,0DAAA;ECwCV;AD3CM;IAGI,0DAAA;EC8CV;ADjDM;IAGI,0DAAA;EC0DV;AD7DM;IAGI,0DAAA;ECgEV;ADnEM;IAGI,0DAAA;ECsEV;AC/GF;IAEI,kBAAA;IAgDA,eAAA;IAAA,eAAA;IAAA,wBAAA;OAAA,qBAAA;YAAA,gBAAA;IAAA,kBAAA;IAAA,wCAAA;IAAA,2DAAA;EDoEF;AClHE;IAEI,aAAA;EDmHN;AChHE;IACI,kBAAA;IACA,WAAA;IACA,MAAA;IACA,SAAA;IACA,WAAA;IACA,wBAAA;IAAA,wCAAA;IACA,yBAAA;IACA,cAAA;IACA,WAAA;IACA,UAAA;EDkHN;AC/GE;IAEI,wBAAA;YAAA,gBAAA;IACA,gBAAA;IACA,yBAAA;IACA,WAAA;IACA,YAAA;IACA,mBAAA;IACA,WAAA;IACA,kBAAA;EDgHN;AC7GE;IAEI,mBAAA;IAAA,4CAAA;ED8GN;AC3GE;IAEI,mBAAA;ED4GN;ACzGE;IAEI,mBAAA;IACA,mBAAA;ED0GN;AEzJF;IAEI,UAAA;EF4JF;AE3JE;IAAA,kGAAA;IAAA,aAAA;EAAA;AAHJ;IAKI,WAAA;EFyJF;AEtJM;EAAA,oBAAA;EAAA,2BAAA;EAAA;AAAA;ACNJ;EAAA,aACI;EADJ,WACI;EADJ,mBACI;EADJ,uBACI;EADJ,WACI;EADJ,kBACI;EADJ,6HACI;EADJ,qEACI;EADJ,4DACI;EADJ,sEACI;EADJ,mEACI;EADJ,wDACI;EADJ,oBACI;EADJ,qBACI;EADJ,oBACI;EADJ,uBACI;EADJ,oBACI;EADJ,6BACI;EADJ;AACI;AADJ;EAAA,4DACI;EADJ,sEACI;EADJ,mEACI;EADJ;AACI;AADJ;EAAA,4DACI;EADJ,sEACI;EADJ,mEACI;EADJ;AACI;AADJ;EAAA,4DACI;EADJ,sEACI;EADJ,mEACI;EADJ,wDACI;IASA,kGAAA;IACA;AAVA;ACQJ;IAEI,kGAAA;IACA,aAAA;EJkKN;AI/JE;IAEI,0BAAA;EJgKN;AI3JM;EAAA,mBAAA;EAAA,kBAAA;EAAA,wCAAA;EAAA,2DAAA;EAAA,8BAAA;EAAA;AAAA;AAKA;EAAA,aAAA;EAAA,mBAAA;EAAA,8BAAA;EAAA;AAAA;AAKA;EAAA,eAAA;EAAA,yBAAA;KAAA,sBAAA;UAAA,iBAAA;EAAA;AAAA;AAEJ;IAEI,oCAAA;IAEA,eAAA;IAAA,QAAA;IAAA,UAAA;IAAA,WAAA;IAAA,SAAA;IAAA,WAAA;IAAA,aAAA;IAAA,UAAA;IAAA,4BAAA;IAAA,wDAAA;IAAA,0BAAA;EJwJN;AItJE;IAGI,cAAA;IAAA,UAAA;EJuJN;AInJM;EAAA,kBAAA;EAAA,kBAAA;EAAA,SAAA;EAAA,WAAA;EAAA,QAAA;EAAA,WAAA;EAAA,aAAA;EAAA,YAAA;EAAA,uBAAA;EAAA,+KAAA;EAAA,+LAAA;EAAA,kBAAA;EAAA,wCAAA;EAAA,2DAAA;EAAA,8BAAA;EAAA,wDAAA;EAAA;AAAA;AAeA;EAAA,aAAA;EAAA,eAAA;EAAA;AAAA;AAAA;;EAAA;IAAA;EAAA;AAAA;AAKA;EAAA,wBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAGJ;IAEI,kFAAA;EJ4IN;AKtNF;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,QAAA;EAAA,UAAA;EAAA,WAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,0BAAA;EAAA,kLAAA;EAAA;AAAA;AAAA;EAAA,yBAAA;EAAA,iLAAA;EAAA;AAAA;AAAA;EAAA,wBAAA;EAAA,gLAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA,6KAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA,6KAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA,qLAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA,qLAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,oLAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,uBAAA;OAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA,oCAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA,oCAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA,oCAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA,oCAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA,kCAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA,oCAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,wCAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,wCAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,wCAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,sCAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,wCAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,wCAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,4DAAA;EAAA,sEAAA;EAAA;AAAA;AAAA;EAAA,6EAAA;EAAA,sEAAA;EAAA;AAAA;AAAA;EAAA,4DAAA;EAAA,sEAAA;EAAA;AAAA;AAAA;EAAA,4DAAA;EAAA,uEAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,6BAAA;UAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;KAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA,gBAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,6BAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,6BAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,0BAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,2BAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,2BAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA,6BAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,8EAAA;EAAA,8FAAA;EAAA,mHAAA;EAAA;AAAA;AAAA;EAAA,mFAAA;EAAA,mGAAA;EAAA,wHAAA;EAAA;AAAA;AAAA;EAAA,8BAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,4BAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA,8BAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA;AAAA;ACAA,iBAAA;AACA;EACI,gCAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,uIAAA;EACA,sFAAA;ANyNJ;AMvNE,aAAA;AACA;EACE,gCAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,uIAAA;EACA,oEAAA;ANyNJ;AMvNE,cAAA;AACA;EACE,gCAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,uIAAA;EACA,0BAAA;ANyNJ;AMvNE,UAAA;AACA;EACE,gCAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,uIAAA;EACA,0BAAA;ANyNJ;AMvNE,eAAA;AACA;EACE,gCAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,uIAAA;EACA,uKAAA;ANyNJ;AMvNE,cAAA;AACA;EACE,gCAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,uIAAA;EACA,gJAAA;ANyNJ;AMvNE,UAAA;AACA;EACE,gCAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,oIAAA;EACA,iMAAA;ANyNJ;AMvNE,iBAAA;AACA;EACE,gCAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,uIAAA;EACA,sFAAA;ANyNJ;AMvNE,aAAA;AACA;EACE,gCAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,uIAAA;EACA,oEAAA;ANyNJ;AMvNE,cAAA;AACA;EACE,gCAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,uIAAA;EACA,0BAAA;ANyNJ;AMvNE,UAAA;AACA;EACE,gCAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,uIAAA;EACA,0BAAA;ANyNJ;AMvNE,eAAA;AACA;EACE,gCAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,uIAAA;EACA,uKAAA;ANyNJ;AMvNE,cAAA;AACA;EACE,gCAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,uIAAA;EACA,gJAAA;ANyNJ;AMvNE,UAAA;AACA;EACE,gCAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,oIAAA;EACA,iMAAA;ANyNJ;AMvNE,iBAAA;AACF;EACE,sBAAA;EACA,kBAAA;EACA,oBAAA;EACA,kBAAA;EACA,mGAAA;EACA,sFAAA;ANyNF;AMvNA,aAAA;AACA;EACE,sBAAA;EACA,kBAAA;EACA,oBAAA;EACA,kBAAA;EACA,mGAAA;EACA,oEAAA;ANyNF;AMvNA,eAAA;AACA;EACE,sBAAA;EACA,kBAAA;EACA,oBAAA;EACA,kBAAA;EACA,mGAAA;EACA,uKAAA;ANyNF;AMvNA,cAAA;AACA;EACE,sBAAA;EACA,kBAAA;EACA,oBAAA;EACA,kBAAA;EACA,mGAAA;EACA,gJAAA;ANyNF;AMvNA,UAAA;AACA;EACE,sBAAA;EACA,kBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gGAAA;EACA,iMAAA;ANyNF;AMvNA,iBAAA;AACA;EACE,sBAAA;EACA,kBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gGAAA;EACA,sFAAA;ANyNF;AMvNA,aAAA;AACA;EACE,sBAAA;EACA,kBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gGAAA;EACA,oEAAA;ANyNF;AMvNA,eAAA;AACA;EACE,sBAAA;EACA,kBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gGAAA;EACA,uKAAA;ANyNF;AMvNA,cAAA;AACA;EACE,sBAAA;EACA,kBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gGAAA;EACA,gJAAA;ANyNF;AMvNA,UAAA;AACA;EACE,sBAAA;EACA,kBAAA;EACA,oBAAA;EACA,kBAAA;EACA,8FAAA;EACA,iMAAA;ANyNF;AO7bA;EACI,oBAAA;EACA,kBAAA;EACA,gBAAA;AP+bJ;;AO5bA;EACI,eAAA;EACA,iBAAA;AP+bJ;;AO5bA;EAEI,oDAAA;EAAA,mDAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;AP8bJ;;AO5bA;EAEI,oDAAA;EAAA,mDAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;AP8bJ;;AO5bA;EAEI,oDAAA;EAAA,mDAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;AP8bJ;;AO5bA;EAEI,oDAAA;EAAA,mDAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;AP8bJ;;AO5bA;EAEI,oDAAA;EAAA,mDAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;AP8bJ;;AO5bA;EAEI;IACI,eAAA;IACA,iBAAA;EP8bN;EO5bE;IAEI,eAAA;IACA,iBAAA;EP6bN;EO3bE;IAEI,eAAA;IACA,iBAAA;EP4bN;EO1bE;IAEI,eAAA;IACA,iBAAA;EP2bN;EOzbE;IAEI,oDAAA;IAAA,mDAAA;IACA,oBAAA;IACA,eAAA;IACA,kBAAA;IACA,gBAAA;IACA,iBAAA;IACA,qBAAA;EP0bN;AACF;AOvbA;EAEI,0DAAA;APwbJ;;AOrbA;EAEI,0DAAA;EACA,iCAAA;EACA,4BAAA;APubJ;;AOrbA;EAEI,0DAAA;EACA,iCAAA;EACA,4BAAA;APubJ;;AOrbA;EAEI,0DAAA;EACA,4BAAA;EACA,wBAAA;APubJ;;AOpbA;EAEI,WAAA;EAEA,cAAA;EAAA,wCAAA;APqbJ;AOnbI;EAEI,cAAA;EAAA,wCAAA;APobR;AOlbQ;EAEI,kCAAA;EAAA,0BAAA;APmbZ;AOhbQ;EAEI,yBAAA;EAAA,kDAAA;EACA,aAAA;APibZ;AO9aQ;EAEI,cAAA;EAAA,wCAAA;AP+aZ;AO3aI;EACI,mBAAA;AP6aR;AO1aI;EACI,eAAA;EACA,iBAAA;AP4aR;AOzaI;EAEI,kBAAA;AP0aR;AOvaI;EACI,cAAA;EAAA,kCAAA;APyaR;AOtaI;EAEI,kBAAA;EACA,gBAAA;EACA,yBAAA;EAAA,6CAAA;EACA,sBAAA;EACA,oBAAA;KAAA,iBAAA;APuaR;AOpaI;EAEI,gBAAA;APqaR;AOlaI;EAEI,yBAAA;EACA,kBAAA;APmaR;AOjaI;EAEI,iBAAA;APkaR;AOhaI;EACI,cAAA;EACA,WAAA;EACA,mBAAA;APkaR;AO/ZI;EAEI,aAAA;EACA,WAAA;EACA,WAAA;EACA,+BAAA;APgaR;AO9ZQ;EAEI,aAAA;EACA,aAAA;AP+ZZ;AO3ZI;EAEI,aAAA;AP4ZR;AO1ZI;EAEI;IAEI,MAAA;EP0ZV;EOxZU;IAEI,cAAA;EPyZd;EOrZM;IAEI,WAAA;IACA,kBAAA;IACA,cAAA;IACA,QAAA;IACA,2BAAA;IACA,WAAA;IACA,iBAAA;IACA,eAAA;IACA,yBAAA;OAAA,sBAAA;YAAA,iBAAA;IACA,WAAA;IACA,kCAAA;IACA,qBAAA;IACA,+BAAA;EPsZV;EOnZU;IAEI,0BAAA;EPoZd;EOjZU;IACI,UAAA;EPmZd;EOjZU;IACI,WAAA;IACA,0CAAA;EPmZd;AACF;;AO/YA;EACI,YAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;APkZJ;;AQlpBI;EACI,gCAAA;ARqpBR;AQ/oBQ;IAAA,gDAAA;EAAA;;ACTR;EAEI,mBAAA;EACA,mFAAA;EACA,kBAAA;EACA,UAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,cAAA;EAAA,wCAAA;AT6pBJ;AS3pBI;EAEI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;AT4pBR;ASzpBI;EAEI,WAAA;EACA,aAAA;EACA,QAAA;EACA,iBAAA;EACA,mBAAA;AT0pBR;ASvpBI;EAEI,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;ATwpBR;ASrpBI;EAEI,yBAAA;EAAA,mDAAA;ATspBR;ASnpBI;EAEI,sBAAA;ATopBR;ASjpBI;EAEI,WAAA;EACA,iBAAA;ATkpBR;AS/oBI;EAGI,0DAAA;AT+oBR;AS5oBI;EAGI,0DAAA;AT4oBR;ASzoBI;EAGI,0DAAA;ATyoBR;AStoBI;EAGI,0DAAA;ATsoBR;ASnoBI;EAGI,0DAAA;ATmoBR;;AS/nBA;EAEI,aAAA;ATioBJ;;AS9nBA;EAEI,aAAA;ATgoBJ;;AA5tBA;EACI,gCAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,sBAAA;EACA,8BAAA;AA+tBJ;;AA5tBA;EAEI,kBAAA;AA8tBJ;AA5tBI;EAEI,eAAA;EACA,gBAAA;EAEA,WAAA;EACA,qBAAA;AA4tBR;AA1tBI;EAEI,OAAA;EACA,MAAA;EACA,uCAAA;AA2tBR;;AAvtBA;EAEI,uBAAA;AAytBJ;AAvtBI;EACI,qBAAA;AAytBR;;AArtBA;EAEI,WAAA;AAutBJ;;AAptBA;EAEI;IAEI,0BAAA;EAqtBN;EAntBE;IAEI,UAAA;EAotBN;EAltBE;IAEI,kBAAA;EAmtBN;EAhtBE;IAEI,WAAA;EAitBN;AACF;;AHpxBA;EAAA;IAAA,eGoxBC;IHpxBD,yBGoxBC;OHpxBD,sBGoxBC;YHpxBD,iBGoxBC;IHpxBD;EGoxBC;EHpxBD;IAAA,cGoxBC;IHpxBD,UGoxBC;EAAA;EHpxBD;IAAA,kBGoxBC;IHpxBD,kBGoxBC;IHpxBD,SGoxBC;IHpxBD,WGoxBC;IHpxBD,QGoxBC;IHpxBD,WGoxBC;IHpxBD,aGoxBC;IHpxBD,YGoxBC;IHpxBD,uBGoxBC;IHpxBD,+KGoxBC;IHpxBD,+LGoxBC;IHpxBD,kBGoxBC;IHpxBD,wCGoxBC;IHpxBD,2DGoxBC;IHpxBD,8BGoxBC;IHpxBD,wDGoxBC;IHpxBD;EGoxBC;EHpxBD;IAAA,mCGoxBC;EAAA;AAAA;;AHpxBD;EAAA;IAAA,aGoxBC;IHpxBD,mBGoxBC;IHpxBD,8BGoxBC;IHpxBD,SGoxBC;IHpxBD,oBGoxBC;IHpxBD;EGoxBC;AAAA;;AHpxBD;EAAA;AGoxBC;;AHpxBD;EAAA;AGoxBC;;AHpxBD;EAAA;AGoxBC;;AHpxBD;EAAA,sBGoxBC;EHpxBD,kCGoxBC;EHpxBD;AGoxBC;;AHpxBD;EAAA,kBGoxBC;EHpxBD,sCGoxBC;EHpxBD;AGoxBC;;AHpxBD;EAAA,kBGoxBC;EHpxBD,wCGoxBC;EHpxBD;AGoxBC;;AHpxBD;EAAA;AGoxBC;;AHpxBD;EAAA;AGoxBC;;AHpxBD;EAAA;AGoxBC;;AHpxBD;;EAAA;IAAA;EGoxBC;AAAA;;AHpxBD;EAAA;AGoxBC;;AHpxBD;;EAAA;IAAA;EGoxBC;;EHpxBD;IAAA;EGoxBC;;EHpxBD;IAAA;EGoxBC;;EHpxBD;IAAA;EGoxBC;;EHpxBD;IAAA;EGoxBC;;EHpxBD;IAAA;EGoxBC;;EHpxBD;IAAA;EGoxBC;;EHpxBD;IAAA;EGoxBC;;EHpxBD;IAAA;EGoxBC;;EHpxBD;IAAA;EGoxBC;;EHpxBD;IAAA,mBGoxBC;IHpxBD;EGoxBC;AAAA;;AHpxBD;;EAAA;IAAA;EGoxBC;;EHpxBD;IAAA;EGoxBC;;EHpxBD;IAAA;EGoxBC;;EHpxBD;IAAA,iBGoxBC;IHpxBD;EGoxBC;;EHpxBD;IAAA;EGoxBC;;EHpxBD;IAAA;EGoxBC;;EHpxBD;IAAA;EGoxBC;;EHpxBD;IAAA;EGoxBC;;EHpxBD;IAAA;EGoxBC;;EHpxBD;IAAA;EGoxBC;;EHpxBD;IAAA;EGoxBC;;EHpxBD;IAAA;EGoxBC;;EHpxBD;IAAA;EGoxBC;;EHpxBD;IAAA;EGoxBC;;EHpxBD;IAAA;EGoxBC;;EHpxBD;IAAA;EGoxBC;;EHpxBD;IAAA;EGoxBC;;EHpxBD;IAAA;EGoxBC;;EHpxBD;IAAA;EGoxBC;;EHpxBD;IAAA;EGoxBC;;EHpxBD;IAAA;EGoxBC;;EHpxBD;IAAA;EGoxBC;;EHpxBD;IAAA;EGoxBC;;EHpxBD;IAAA;EGoxBC;;EHpxBD;IAAA;EGoxBC;;EHpxBD;IAAA;EGoxBC;;EHpxBD;IAAA;EGoxBC;;EHpxBD;IAAA;EGoxBC;;EHpxBD;IAAA,gCGoxBC;IHpxBD,wLGoxBC;IHpxBD;EGoxBC;;EHpxBD;IAAA,0BGoxBC;IHpxBD,kLGoxBC;IHpxBD;EGoxBC;;EHpxBD;IAAA,qBGoxBC;IHpxBD,6KGoxBC;IHpxBD;EGoxBC;;EHpxBD;IAAA,qBGoxBC;IHpxBD,6KGoxBC;IHpxBD;EGoxBC;;EHpxBD;;IAAA;MAAA;IGoxBC;EAAA;;EHpxBD;IAAA;EGoxBC;;EHpxBD;IAAA;EGoxBC;;EHpxBD;IAAA;EGoxBC;;EHpxBD;IAAA;EGoxBC;;EHpxBD;IAAA;EGoxBC;;EHpxBD;IAAA;EGoxBC;;EHpxBD;IAAA;EGoxBC;;EHpxBD;IAAA;EGoxBC;;EHpxBD;IAAA;EGoxBC;;EHpxBD;IAAA;EGoxBC;;EHpxBD;IAAA;EGoxBC;;EHpxBD;IAAA;EGoxBC;;EHpxBD;IAAA;EGoxBC;;EHpxBD;IAAA;EGoxBC;;EHpxBD;IAAA,kBGoxBC;IHpxBD,qCGoxBC;IHpxBD;EGoxBC;;EHpxBD;IAAA,kBGoxBC;IHpxBD,wCGoxBC;IHpxBD;EGoxBC;;EHpxBD;IAAA;EGoxBC;;EHpxBD;IAAA;EGoxBC;;EHpxBD;IAAA,iBGoxBC;IHpxBD;EGoxBC;;EHpxBD;IAAA,qBGoxBC;IHpxBD;EGoxBC;;EHpxBD;IAAA,oBGoxBC;IHpxBD;EGoxBC;;EHpxBD;IAAA,mBGoxBC;IHpxBD;EGoxBC;;EHpxBD;IAAA,iBGoxBC;IHpxBD;EGoxBC;;EHpxBD;IAAA,oBGoxBC;IHpxBD;EGoxBC;;EHpxBD;IAAA,mBGoxBC;IHpxBD;EGoxBC;;EHpxBD;IAAA,iBGoxBC;IHpxBD;EGoxBC;;EHpxBD;IAAA,iBGoxBC;IHpxBD;EGoxBC;;EHpxBD;IAAA,iBGoxBC;IHpxBD;EGoxBC;;EHpxBD;IAAA;EGoxBC;;EHpxBD;IAAA;EGoxBC;;EHpxBD;IAAA;EGoxBC;;EHpxBD;IAAA;EGoxBC;;EHpxBD;IAAA;EGoxBC;;EHpxBD;IAAA;EGoxBC;;EHpxBD;IAAA;EGoxBC;;EHpxBD;IAAA;EGoxBC;;EHpxBD;IAAA;EGoxBC;;EHpxBD;IAAA;EGoxBC;;EHpxBD;IAAA;EGoxBC;;EHpxBD;IAAA;EGoxBC;;EHpxBD;IAAA;EGoxBC;;EHpxBD;IAAA;EGoxBC;;EHpxBD;IAAA;EGoxBC;;EHpxBD;IAAA,iBGoxBC;IHpxBD;EGoxBC;;EHpxBD;IAAA;EGoxBC;;EHpxBD;IAAA;EGoxBC;;EHpxBD;IAAA,mBGoxBC;IHpxBD;EGoxBC;;EHpxBD;IAAA;EGoxBC;;EHpxBD;IAAA;EGoxBC;;EHpxBD;IAAA;EGoxBC;;EHpxBD;IAAA,oBGoxBC;IHpxBD,6BGoxBC;IHpxBD;EGoxBC;;EHpxBD;IAAA,oBGoxBC;IHpxBD,6BGoxBC;IHpxBD;EGoxBC;;EHpxBD;IAAA,oBGoxBC;IHpxBD,6BGoxBC;IHpxBD;EGoxBC;;EHpxBD;IAAA,oBGoxBC;IHpxBD,0BGoxBC;IHpxBD;EGoxBC;AAAA","sourcesContent":["@tailwind base;\n","@tailwind components;\n",".icon {\n\n    $icon: &;\n\n    background-size: 100% 100%;\n    background-repeat: no-repeat;\n    display: block;\n    content: \"\";\n\n    $icons: (\n        \"hamburger\",\n        \"sign-in-alt\",\n        \"mail\",\n        \"cross\",\n        \"ind-expand-arrow\",\n        \"social-vk\",\n        \"social-telegram\",\n        \"link\",\n        \"star\",\n        \"star-active\",\n        \"angle\",\n        \"search\",\n        \"chevron-down\",\n        \"spinner\",\n        \"wallet\",\n        \"car\",\n        \"phone\",\n    );\n\n    &-fixed {\n        \n        @extend #{$icon};\n\n        background-image: var(--icon);\n    }\n\n    @each $slug in $icons {\n\n        &-#{$slug} {\n\n            @extend #{$icon};\n            background-image: url(\"./../img/#{$slug}.svg\");\n        }\n        \n        &-fixed-#{$slug} {\n\n            --icon: url(\"./../img/#{$slug}.svg\");\n        }\n    }\n}","@import \"@src/styles/tailwind.scss\";\n@import \"@src/styles/fonts.scss\";\n@import \"@src/styles/content.scss\";\n@import \"@src/styles/rate.scss\";\n@import \"@src/styles/share.scss\";\n\nbody {\n    font-family: \"Noto Sans Display\";\n    font-size: 16px;\n    font-style: normal;\n    line-height: 150%;\n    letter-spacing: 0.16px;\n    visibility: visible !important;\n}\n\n[data-edit] {\n    \n    position: relative;\n\n    &[data-empty]:before {\n\n        min-width: 1rem;\n        min-height: 1rem;\n    \n        content: \"\";\n        display: inline-block;\n    }\n    & .customize-partial-edit-shortcut {\n\n        left: 0;\n        top: 0;\n        transform: translateX(-100%) !important;\n    }\n}\n\n.customize-partial-edit-shortcut-button {\n    \n    opacity: 0.1 !important;\n\n    &:hover {\n        opacity: 1 !important;\n    }\n}\n\n.tablet-w-50 {\n\n    width: 100%;\n}\n\n@media all and (min-width: 768px) and (max-width: 1184px) {\n\n    .mobile\\:flex-nowrap {\n\n        flex-wrap: wrap !important;\n    }\n    .tablet-w-50 {\n\n        width: 50%;\n    }\n    .tablet-w-50 + .tablet-w-50 {\n\n        padding-left: 1rem;\n    }\n    \n    .tablet-w-100 {\n\n        width: 100%;\n    }\n}",".range {\n\n    position: relative;\n\n    &:focus-visible {\n\n        outline: none;\n    }\n\n    &:before {\n        position: absolute;\n        left: -100%;\n        top: 0;\n        bottom: 0;\n        width: 100%;\n        transform: translateX(var(--percent, 0));\n        background-color: #5D9922;\n        display: block;\n        content: \"\";\n        z-index: 1;\n    }\n\n    &::-webkit-slider-thumb {\n\n        appearance: none;\n        background: #fff;\n        border: 4px solid #5D9922;\n        width: 24px;\n        height: 24px;\n        border-radius: 100%;\n        z-index: 10;\n        position: relative;\n    }\n\n    &::-webkit-slider-thumb:hover {\n\n        background: var(--color-primary-50, #F2FAE6);\n    }\n\n    &::-webkit-slider-thumb:active {\n\n        background: #5D9922;\n    }\n\n    &:focus-visible::-webkit-slider-thumb {\n\n        background: #5D9922;\n        border-color: white;\n    }\n\n    @apply bg-neutral-300 h-1 cursor-pointer appearance-none;\n}",".post-item {\n\n    /** main */\n    @apply focus-shadow;\n\n    /** title */\n    &:hover &__title {\n        \n        @apply text-primary-500;\n    }\n}",".button-special {\n\n    @apply\n        flex items-center px-6 py-3 justify-center w-full gap-2 text-white rounded-[4px]\n        bg-gradient-to-r from-[#F2AA18] to-[#F26A3D]\n        hover:from-[#ED8B18] hover:to-[#E75845]\n        focus:from-[#E2800D] focus:to-[#E54B36]\n        focus-visible:from-[#F2AA18] focus-visible:to-[#F26A3D]\n        ;\n\n    &:focus-visible {\n        \n        box-shadow: 4px -4px 0px #FFDFC9, -4px -4px 0px #FFDFC9, -4px 4px 0px #FFDFC9, 4px 4px 0px #FFDFC9;\n        outline: none;\n    }\n}","@import \"tailwindcss/base\";\n@import \"tailwindcss/components\";\n@import \"tailwindcss/utilities\";\n\n@layer components {\n    \n    @import \"@src/styles/icons.scss\";\n    @import \"@src/styles/range.scss\";\n    @import \"@src/styles/post.scss\";\n    @import \"@src/styles/button.scss\";\n\n    .focus-shadow:focus-visible {\n\n        box-shadow: 4px -4px 0px #F2FAE6, -4px -4px 0px #F2FAE6, -4px 4px 0px #F2FAE6, 4px 4px 0px #F2FAE6;\n        outline: none;\n    }\n\n    .focus-outline:focus-visible {\n\n        outline: 4px solid #F2FAE6;\n    }\n\n    .focus-background:focus-visible {\n        \n        @apply bg-primary-50 outline-none rounded-2xl;\n    }\n\n    .flex-block {\n\n        @apply flex items-center justify-between gap-4;\n    }\n\n    .clickable {\n\n        @apply cursor-pointer select-none whitespace-nowrap;\n    }\n    .header-overlay {\n\n        background-color: rgba(0, 0, 0, .8);\n\n        @apply transition-opacity opacity-0 inset-0 z-40 fixed hidden;\n    }\n    .header-menu--open + .header-overlay {\n\n        display: block;\n        @apply block opacity-100;\n    }\n    .header-menu {\n\n        @apply absolute left-0 bottom-0 w-[250px] bg-white transition-transform -translate-x-full invisible z-50 top-0 h-screen;\n\n    }\n    .header-menu--open {\n        \n        transform: translateX(0);\n    }\n\n    .header-menu-inline {\n        \n        @apply flex-block flex-auto mr-2;\n    }\n\n    .footer-section {\n\n        @apply flex flex-wrap gap-2 desktop:w-[368px];\n    }\n\n    .no-scrollbar {\n\n        @apply [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none];\n    }\n\n    .shadow-t {\n        \n        box-shadow: 0px 0px 8px rgba(61, 61, 61, 0.12), 0px 2px 4px rgba(61, 61, 61, 0.06);\n    }\n}","@tailwind utilities;\n","/* cyrillic-ext */\n@font-face {\n    font-family: 'Noto Sans Display';\n    font-style: normal;\n    font-weight: 400;\n    font-stretch: 100%;\n    font-display: swap;\n    src: url(https://fonts.gstatic.com/s/notosansdisplay/v26/RLpWK4fy6r6tOBEJg0IAKzqdFZVZxpMkXJMhnB9XjO1o90LEVssiCKY.woff2) format('woff2');\n    unicode-range: U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F;\n  }\n  /* cyrillic */\n  @font-face {\n    font-family: 'Noto Sans Display';\n    font-style: normal;\n    font-weight: 400;\n    font-stretch: 100%;\n    font-display: swap;\n    src: url(https://fonts.gstatic.com/s/notosansdisplay/v26/RLpWK4fy6r6tOBEJg0IAKzqdFZVZxpMkXJMhnB9XjO1o90LEX8siCKY.woff2) format('woff2');\n    unicode-range: U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;\n  }\n  /* greek-ext */\n  @font-face {\n    font-family: 'Noto Sans Display';\n    font-style: normal;\n    font-weight: 400;\n    font-stretch: 100%;\n    font-display: swap;\n    src: url(https://fonts.gstatic.com/s/notosansdisplay/v26/RLpWK4fy6r6tOBEJg0IAKzqdFZVZxpMkXJMhnB9XjO1o90LEV8siCKY.woff2) format('woff2');\n    unicode-range: U+1F00-1FFF;\n  }\n  /* greek */\n  @font-face {\n    font-family: 'Noto Sans Display';\n    font-style: normal;\n    font-weight: 400;\n    font-stretch: 100%;\n    font-display: swap;\n    src: url(https://fonts.gstatic.com/s/notosansdisplay/v26/RLpWK4fy6r6tOBEJg0IAKzqdFZVZxpMkXJMhnB9XjO1o90LEWMsiCKY.woff2) format('woff2');\n    unicode-range: U+0370-03FF;\n  }\n  /* vietnamese */\n  @font-face {\n    font-family: 'Noto Sans Display';\n    font-style: normal;\n    font-weight: 400;\n    font-stretch: 100%;\n    font-display: swap;\n    src: url(https://fonts.gstatic.com/s/notosansdisplay/v26/RLpWK4fy6r6tOBEJg0IAKzqdFZVZxpMkXJMhnB9XjO1o90LEVMsiCKY.woff2) format('woff2');\n    unicode-range: U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+0300-0301, U+0303-0304, U+0308-0309, U+0323, U+0329, U+1EA0-1EF9, U+20AB;\n  }\n  /* latin-ext */\n  @font-face {\n    font-family: 'Noto Sans Display';\n    font-style: normal;\n    font-weight: 400;\n    font-stretch: 100%;\n    font-display: swap;\n    src: url(https://fonts.gstatic.com/s/notosansdisplay/v26/RLpWK4fy6r6tOBEJg0IAKzqdFZVZxpMkXJMhnB9XjO1o90LEVcsiCKY.woff2) format('woff2');\n    unicode-range: U+0100-02AF, U+0304, U+0308, U+0329, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;\n  }\n  /* latin */\n  @font-face {\n    font-family: 'Noto Sans Display';\n    font-style: normal;\n    font-weight: 400;\n    font-stretch: 100%;\n    font-display: swap;\n    src: url(https://fonts.gstatic.com/s/notosansdisplay/v26/RLpWK4fy6r6tOBEJg0IAKzqdFZVZxpMkXJMhnB9XjO1o90LEW8si.woff2) format('woff2');\n    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;\n  }\n  /* cyrillic-ext */\n  @font-face {\n    font-family: 'Noto Sans Display';\n    font-style: normal;\n    font-weight: 600;\n    font-stretch: 100%;\n    font-display: swap;\n    src: url(https://fonts.gstatic.com/s/notosansdisplay/v26/RLpWK4fy6r6tOBEJg0IAKzqdFZVZxpMkXJMhnB9XjO1o90LEVssiCKY.woff2) format('woff2');\n    unicode-range: U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F;\n  }\n  /* cyrillic */\n  @font-face {\n    font-family: 'Noto Sans Display';\n    font-style: normal;\n    font-weight: 600;\n    font-stretch: 100%;\n    font-display: swap;\n    src: url(https://fonts.gstatic.com/s/notosansdisplay/v26/RLpWK4fy6r6tOBEJg0IAKzqdFZVZxpMkXJMhnB9XjO1o90LEX8siCKY.woff2) format('woff2');\n    unicode-range: U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;\n  }\n  /* greek-ext */\n  @font-face {\n    font-family: 'Noto Sans Display';\n    font-style: normal;\n    font-weight: 600;\n    font-stretch: 100%;\n    font-display: swap;\n    src: url(https://fonts.gstatic.com/s/notosansdisplay/v26/RLpWK4fy6r6tOBEJg0IAKzqdFZVZxpMkXJMhnB9XjO1o90LEV8siCKY.woff2) format('woff2');\n    unicode-range: U+1F00-1FFF;\n  }\n  /* greek */\n  @font-face {\n    font-family: 'Noto Sans Display';\n    font-style: normal;\n    font-weight: 600;\n    font-stretch: 100%;\n    font-display: swap;\n    src: url(https://fonts.gstatic.com/s/notosansdisplay/v26/RLpWK4fy6r6tOBEJg0IAKzqdFZVZxpMkXJMhnB9XjO1o90LEWMsiCKY.woff2) format('woff2');\n    unicode-range: U+0370-03FF;\n  }\n  /* vietnamese */\n  @font-face {\n    font-family: 'Noto Sans Display';\n    font-style: normal;\n    font-weight: 600;\n    font-stretch: 100%;\n    font-display: swap;\n    src: url(https://fonts.gstatic.com/s/notosansdisplay/v26/RLpWK4fy6r6tOBEJg0IAKzqdFZVZxpMkXJMhnB9XjO1o90LEVMsiCKY.woff2) format('woff2');\n    unicode-range: U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+0300-0301, U+0303-0304, U+0308-0309, U+0323, U+0329, U+1EA0-1EF9, U+20AB;\n  }\n  /* latin-ext */\n  @font-face {\n    font-family: 'Noto Sans Display';\n    font-style: normal;\n    font-weight: 600;\n    font-stretch: 100%;\n    font-display: swap;\n    src: url(https://fonts.gstatic.com/s/notosansdisplay/v26/RLpWK4fy6r6tOBEJg0IAKzqdFZVZxpMkXJMhnB9XjO1o90LEVcsiCKY.woff2) format('woff2');\n    unicode-range: U+0100-02AF, U+0304, U+0308, U+0329, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;\n  }\n  /* latin */\n  @font-face {\n    font-family: 'Noto Sans Display';\n    font-style: normal;\n    font-weight: 600;\n    font-stretch: 100%;\n    font-display: swap;\n    src: url(https://fonts.gstatic.com/s/notosansdisplay/v26/RLpWK4fy6r6tOBEJg0IAKzqdFZVZxpMkXJMhnB9XjO1o90LEW8si.woff2) format('woff2');\n    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;\n  }\n  /* cyrillic-ext */\n@font-face {\n  font-family: 'Raleway';\n  font-style: italic;\n  font-weight: 100 900;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/raleway/v29/1Ptsg8zYS_SKggPNyCg4QIFqPfE.woff2) format('woff2');\n  unicode-range: U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F;\n}\n/* cyrillic */\n@font-face {\n  font-family: 'Raleway';\n  font-style: italic;\n  font-weight: 100 900;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/raleway/v29/1Ptsg8zYS_SKggPNyCg4SYFqPfE.woff2) format('woff2');\n  unicode-range: U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;\n}\n/* vietnamese */\n@font-face {\n  font-family: 'Raleway';\n  font-style: italic;\n  font-weight: 100 900;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/raleway/v29/1Ptsg8zYS_SKggPNyCg4QoFqPfE.woff2) format('woff2');\n  unicode-range: U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+0300-0301, U+0303-0304, U+0308-0309, U+0323, U+0329, U+1EA0-1EF9, U+20AB;\n}\n/* latin-ext */\n@font-face {\n  font-family: 'Raleway';\n  font-style: italic;\n  font-weight: 100 900;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/raleway/v29/1Ptsg8zYS_SKggPNyCg4Q4FqPfE.woff2) format('woff2');\n  unicode-range: U+0100-02AF, U+0304, U+0308, U+0329, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;\n}\n/* latin */\n@font-face {\n  font-family: 'Raleway';\n  font-style: italic;\n  font-weight: 100 900;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/raleway/v29/1Ptsg8zYS_SKggPNyCg4TYFq.woff2) format('woff2');\n  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;\n}\n/* cyrillic-ext */\n@font-face {\n  font-family: 'Raleway';\n  font-style: normal;\n  font-weight: 100 900;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/raleway/v29/1Ptug8zYS_SKggPNyCAIT5lu.woff2) format('woff2');\n  unicode-range: U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F;\n}\n/* cyrillic */\n@font-face {\n  font-family: 'Raleway';\n  font-style: normal;\n  font-weight: 100 900;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/raleway/v29/1Ptug8zYS_SKggPNyCkIT5lu.woff2) format('woff2');\n  unicode-range: U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;\n}\n/* vietnamese */\n@font-face {\n  font-family: 'Raleway';\n  font-style: normal;\n  font-weight: 100 900;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/raleway/v29/1Ptug8zYS_SKggPNyCIIT5lu.woff2) format('woff2');\n  unicode-range: U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+0300-0301, U+0303-0304, U+0308-0309, U+0323, U+0329, U+1EA0-1EF9, U+20AB;\n}\n/* latin-ext */\n@font-face {\n  font-family: 'Raleway';\n  font-style: normal;\n  font-weight: 100 900;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/raleway/v29/1Ptug8zYS_SKggPNyCMIT5lu.woff2) format('woff2');\n  unicode-range: U+0100-02AF, U+0304, U+0308, U+0329, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;\n}\n/* latin */\n@font-face {\n  font-family: 'Raleway';\n  font-style: normal;\n  font-weight: 100 900;\n  font-display: swap;\n  src: url(https://fonts.gstatic.com/s/raleway/v29/1Ptug8zYS_SKggPNyC0ITw.woff2) format('woff2');\n  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;\n}","h1 {\n    font-family: Raleway;\n    font-style: normal;\n    font-weight: 700;\n}\n\n.title1 {\n    font-size: 28px;\n    line-height: 35px;\n}\n\nh2, .title2 {\n    \n    font-variant-numeric: lining-nums proportional-nums;\n    font-family: Raleway;\n    font-size: 24px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 30px;\n    letter-spacing: 0.1px;\n}\nh3, .title3 {\n    \n    font-variant-numeric: lining-nums proportional-nums;\n    font-family: Raleway;\n    font-size: 20px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 25px;\n    letter-spacing: 0.1px;\n}\nh4, .title4 {\n    \n    font-variant-numeric: lining-nums proportional-nums;\n    font-family: Raleway;\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 22.5px;\n    letter-spacing: 0.1px;\n}\nh5, .title5 {\n    \n    font-variant-numeric: lining-nums proportional-nums;\n    font-family: Raleway;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 20px;\n    letter-spacing: 0.1px;\n}\nh6, .title6 {\n    \n    font-variant-numeric: lining-nums proportional-nums;\n    font-family: Raleway;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 17.5px;\n    letter-spacing: 0.1px;\n}\n@media all and (min-width: 776px) {\n\n    .title1 {\n        font-size: 40px;\n        line-height: 50px;\n    }\n    h2, .title2 {\n\n        font-size: 32px;\n        line-height: 40px;\n    }\n    h3, .title3 {\n\n        font-size: 34px;\n        line-height: 30px;\n    }\n    h4, .title4 {\n\n        font-size: 20px;\n        line-height: 25px;\n    }\n    h6, .title6 {\n        \n        font-variant-numeric: lining-nums proportional-nums;\n        font-family: Raleway;\n        font-size: 16px;\n        font-style: normal;\n        font-weight: 700;\n        line-height: 20px;\n        letter-spacing: 0.1px;\n    }\n}\n\n.post-default-background {\n\n    background-image: url('@src/img/bg.svg');\n}\n\n.post-topline-background {\n\n    background-image: url('@src/img/com-header-bg.svg');\n    background-position: center right;\n    background-repeat: no-repeat;\n}\n.post-lime-background {\n\n    background-image: url('@src/img/bg-lime.svg');\n    background-position: center right;\n    background-repeat: no-repeat;\n}\n.lime-logo {\n    \n    background-image: url('@src/img/logo-lime.svg');\n    background-repeat: no-repeat;\n    background-size: contain;\n}\n\n.content {\n\n    width: 100%;\n\n    color: var(--color-neutral-900, #3D3D3D);\n\n    a {\n\n        color: var(--color-primary-500, #5D9922);\n\n        &:hover {\n\n            text-decoration: underline;\n        }\n\n        &:focus-visible {\n\n            background-color: var(--color-primary-50, #F2FAE6);\n            outline: none;\n        }\n\n        &:disabled {\n\n            color: var(--color-neutral-600, #B0B0B0);\n        }\n    }\n\n    & > p, & > ul, & > div, & > ol, & > figure {\n        margin-bottom: 24px;\n    }\n\n    h1 {\n        font-size: 40px;\n        line-height: 50px;\n    }\n\n    h2, h3, h4, h5, h6 {\n\n        margin-bottom: 8px;\n    }\n\n    h2, .title2 {\n        color: var(--Neutral-900, #3D3D3D);\n    }\n\n    figure img {\n        \n        border-radius: 8px;\n        overflow:hidden;\n        border: 1px solid var(--Neutral-300, #EBEBEB);\n        width: 100% !important;\n        object-fit: cover;\n    }\n\n    & > figure {\n\n        margin-top: 40px;\n    }\n\n    img[data-src] {\n\n        background-color: #F5F5F5;\n        aspect-ratio: 16/9;\n    }\n    img[data-src].aspect-square {\n\n        aspect-ratio: 1/1;\n    }\n    br {\n        display: block;\n        content: \"\";\n        margin-bottom: 20px;\n    }\n\n    & .wp-block-gallery {\n\n        display: flex;\n        width: 100%;\n        gap: 0.5rem;\n        transition: transform 0.5s ease;\n\n        & .wp-block-image {\n\n            display: flex;\n            flex: 0 0 85%;\n        }\n    }\n\n    & .wp-block-gallery-stick {\n        @extend .icon-angle;\n        display: none;\n    }\n    @media all and (min-width: 776px) {\n\n        & .wp-block-gallery {\n            \n            gap: 0;\n\n            & .wp-block-image {\n    \n                flex: 0 0 100%;\n            }\n        }\n        \n        & .wp-block-gallery-stick {\n\n            content: \"\";\n            position: absolute;\n            display: block;\n            top: 50%;\n            transform: translateY(-50%);\n            width: 48px;\n            aspect-ratio: 1/1;\n            cursor: pointer;\n            user-select: none;\n            z-index: 10;\n            background-position: center center;\n            background-size: 24px;\n            transform-origin: center center;\n\n\n            &:hover {\n\n                background-size: 48px 48px;\n            }\n\n            &--left {\n                left: 15px;\n            }\n            &--right {\n                right: 15px;\n                transform: translateY(-50%) rotate(180deg);\n            }\n        }\n    }\n}\n.no-scroll {\n    height: 100%;\n    overflow: hidden;\n    width: 100%;\n    position: fixed;\n}",".rate {\n\n    &__item {\n        transition: 0.15s ease transform;\n    }\n\n    &__item:hover,\n    &__item:hover ~ &__item {\n\n        @apply icon-fixed-star-active;\n    }\n}",".ya-share2 .ya-share2__popup > .ya-share2__list {\n\n    background: #FFFFFF;\n    box-shadow: 0px 0px 16px rgba(61, 61, 61, 0.12), 0px 4px 8px rgba(61, 61, 61, 0.06);\n    border-radius: 4px;\n    z-index: 7;\n    display: none;\n    flex-direction: column;\n    align-items: flex-start;\n    padding: 4px 0px;\n    max-width: 362px;\n    width: 100%;\n    position: absolute;\n    left: 0;\n    top: 0;\n    color: var(--color-neutral-900, #3D3D3D);\n\n    & .ya-share2__item {\n\n        display: flex;\n        flex-direction: row;\n        align-items: flex-start;\n        width: 100%;\n    }\n\n    & .ya-share2__link {\n        \n        width: 100%;\n        display: flex;\n        gap: 8px;\n        padding: 8px 16px;\n        align-items: center;\n    }\n    \n    & .ya-share2__title {\n\n        font-family: 'Raleway';\n        font-style: normal;\n        font-weight: 400;\n        font-size: 16px;\n        line-height: 24px;\n        letter-spacing: 0.01em;\n    }\n\n    & .ya-share2__link:hover {\n        \n        background-color: var(--color-neutral-100, #f5f5f5);\n    }\n\n    & .ya-share2__link:focus {\n        \n        background-color: #fff;\n    }\n\n    & .ya-share2__icon {\n\n        width: 24px;\n        aspect-ratio: 1/1;\n    }\n    \n    & .ya-share2__item_copy .ya-share2__icon {\n\n        @extend .icon;\n        background-image: url(\"./../img/share-copy.svg\");\n    }\n    \n    & .ya-share2__item_service_vkontakte .ya-share2__icon {\n\n        @extend .icon;\n        background-image: url(\"./../img/share-vk.svg\");\n    }\n    \n    & .ya-share2__item_service_odnoklassniki .ya-share2__icon {\n\n        @extend .icon;\n        background-image: url(\"./../img/share-ok.svg\");\n    }\n    \n    & .ya-share2__item_service_telegram .ya-share2__icon {\n\n        @extend .icon;\n        background-image: url(\"./../img/share-tg.svg\");\n    }\n    \n    & .ya-share2__item_service_whatsapp .ya-share2__icon {\n\n        @extend .icon;\n        background-image: url(\"./../img/share-whatsapp.svg\");\n    }\n}\n\n.ya-share2 .ya-share2__popup.ya-share2__popup_visible > .ya-share2__list {\n\n    display: flex;\n}\n\n.ya-share2__input_copy {\n\n    display: none;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
